//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// KitchenManagement - Custom Order Preparation and Management within a Store or Restuarant
//              Version 1.042 - February 17, 2023
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React, { Component, createContext, useContext, useState, useEffect, useMemo, useRef, useCallback} from 'react';
import { withRouter } from './withRouter';
import { Grid,GridColumn } from '@progress/kendo-react-grid';
import { TabStrip, TabStripTab, Splitter, TileLayout } from '@progress/kendo-react-layout'; 
import { TaskBoard,TaskBoardToolbar } from "@progress/kendo-react-taskboard";
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DropDownList } from '@progress/kendo-react-dropdowns';  
import { DateTimePicker } from '@progress/kendo-react-dateinputs';   
import { Popup } from '@progress/kendo-react-popup';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from "@progress/kendo-react-inputs";
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { orderBy, filterBy } from '@progress/kendo-data-query';
import { ListView,ListViewHeader,ListViewFooter } from '@progress/kendo-react-listview';
import { Switch,MaskedTextBox } from "@progress/kendo-react-inputs";
//--------------                                                             
//import { GridColumn } from "./column";
import { Card } from "./card";
import { guid } from '@progress/kendo-react-common';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { Scheduler, TimelineView, DayView, WeekView, MonthView, AgendaView } from '@progress/kendo-react-scheduler';
import { SchedControl, getTaskID } from './CommonControls.js';
import weekData from 'cldr-core/supplemental/weekData.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import numbers from 'cldr-numbers-full/main/es/numbers.json';
import dateFields from 'cldr-dates-full/main/es/dateFields.json';
import currencies from 'cldr-numbers-full/main/es/currencies.json';
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json';
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json';
import '@progress/kendo-date-math/tz/Etc/UTC';
import '@progress/kendo-date-math/tz/Europe/Sofia';
import '@progress/kendo-date-math/tz/Europe/Madrid';
import '@progress/kendo-date-math/tz/Asia/Dubai';
import '@progress/kendo-date-math/tz/Asia/Tokyo';
import '@progress/kendo-date-math/tz/America/New_York';
import '@progress/kendo-date-math/tz/America/Los_Angeles';
//--------------
import { NumericTextBox } from '@progress/kendo-react-inputs'; 
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { SessionInfo } from './App';
import moment from 'moment';
import PageHeader from './PageHeader.js';
import PageFooter from './PageFooter.js';
import PageSide from './PageSide.js';
import { cards } from "./cards.js";
//-------------------------------------- TimeZone -----------------------------   
import { timezoneNames } from "@progress/kendo-date-math";
//-----------------------------------------------------------------------------
import { CallOM,CallOMT,GetTableRow,GetTableRowRaw,GetTableRowTrans,GetTableData,GetTableSearch,UpdateRow,DeleteRowTry,GetFileExtension,displayMessage,displayError,displayNotify,getHelpTopics,getHelpDetail,LogOffResetMsg,OMTrace,getImageFileFromServer,GetDropdownData,GetDependentDropdownData,displayWarning,MaskString,UnmaskString, TYP, CTYP } from './CommonCode.js';
import { TimePickerCell,MoneyCell,BoolCell,cellBool,cellQuantity,cellOptions,cellCurrency,SetProductType,SetProductItemCategory,ProductItemCategoryDropDownCell,SetPricingType,EditGridCommandCell } from './CommonFormat.js';
import { ENAppCnfg } from './CommonInfo.js';
import { getAmenities } from './AppCommon.js';
//---------------
const StoreLocationsO = [{ n: 'StoreLocationID', t: 24, p: 0 }, { n: 'StoreName', t: 21, p: 0 }, { n: 'Description', t: 21, p: 0 }, { n: 'CompanyID', t: 24, p: 0 }, { n: 'LocationID', t: 24, p: 0 }, { n: 'CurrentlyOpen', t: 22, p: 0 }, { n: 'AreaSize', t: 16, p: 0 }, { n: 'ContactID', t: 24, p: 0 }, { n: 'CurrentWaitTime', t: 24, p: 0 }, { n: 'StoreGroupID', t: 24, p: 0 }, { n: 'TaxRate', t: 16, p: 0 }, { n: 'TaxRate2', t: 16, p: 0 }, { n: 'TaxRate3', t: 16, p: 0 }, { n: 'TaxRuleID', t: 24, p: 0 }, { n: 'TipRate1', t: 16, p: 0 }, { n: 'TipRate2', t: 16, p: 0 }, { n: 'TipRate3', t: 16, p: 0 }, { n: 'MaximumPurchaseAmount', t: 28, p: 0 }, { n: 'StandardMarkupPercent', t: 16, p: 8 }, { n: 'ExtendedMarkupPercent', t: 16, p: 8 }, { n: 'SetPriceType', t: 201, p: 0 }, { n: 'SpecialtyList', t: 21, p: 0 }, { n: 'MarketingMessage', t: 21, p: 0 }, { n: 'PromotionalMessage', t: 21, p: 0 }, { n: 'StoreImage', t: 41, p: 0 }, { n: 'StoreAmenities', t: 15, p: 0 }, { n: 'LocationID', t: 24, p: 0 }, { n: 'LocationName', t: 21, p: 0 }, { n: 'Description', t: 21, p: 0 }, { n: 'CompanyID', t: 24, p: 0 }, { n: 'LocationTypeID', t: 24, p: 0 }, { n: 'UnitNumber', t: 21, p: 0 }, { n: 'Address', t: 21, p: 0 }, { n: 'CityName', t: 21, p: 0 }, { n: 'ProvinceStateID', t: 24, p: 0 }, { n: 'CountryID', t: 24, p: 0 }, { n: 'PostalCode', t: 21, p: 0 }, { n: 'PhoneNumber', t: 21, p: 0 }, { n: 'EmailAddress', t: 21, p: 0 }, { n: 'ContactID', t: 24, p: 0 }, { n: 'AccountID', t: 24, p: 0 }, { n: 'DUNSNumber', t: 21, p: 0 }, { n: 'GeoLocation', t: 21, p: 0 }, { n: 'ControlFlags', t: 27, p: 0 }];
const StoreItemsO = [{ n: 'StoreItemID', t: 195, p: 100 }, { n: 'StoreLocationID', t: 195, p: 100 }, { n: 'ReferenceItemID', t: 195, p: 100 }, { n: 'AssociatedItemID', t: 195, p: 100 }, { n: 'ItemName', t: 21, p: 0 }, { n: 'ItemDescription', t: 21, p: 0 }, { n: 'ItemFullDescription', t: 29, p: 0 }, { n: 'ProductItemCategoryID', t: 195, p: 100 }, { n: 'ProductItemGroupID', t: 195, p: 100 }, { n: 'ProductItemTypeID', t: 195, p: 100 }, { n: 'BrandID', t: 195, p: 100 }, { n: 'UPCNumber', t: 21, p: 0 }, { n: 'BarcodeNumber', t: 21, p: 0 }, { n: 'ItemStatusID', t: 195, p: 100 }, { n: 'PackagingTypeID', t: 195, p: 100 }, { n: 'ItemSizeCodeID', t: 195, p: 100 }, { n: 'TotalQuantity', t: 16, p: 0 }, { n: 'TotalNetWeight', t: 16, p: 0 }, { n: 'ReservedQuantity', t: 16, p: 0 }, { n: 'LockedQuantity', t: 16, p: 0 }, { n: 'AvailableQuantity', t: 16, p: 0 }, { n: 'DocumentID', t: 41, p: 0 }, { n: 'ImageID', t: 41, p: 0 }, { n: 'ItemPrice', t: 28, p: 0 }, { n: 'PromotionPrice', t: 28, p: 0 }, { n: 'Promotion2Price', t: 28, p: 0 }, { n: 'PromotionType', t: 201, p: 0 }, { n: 'StorePromotionID', t: 195, p: 100 }, { n: 'ShelfLifeDays', t: 24, p: 0 }, { n: 'ItemNetWeight', t: 16, p: 0 }, { n: 'PricingTypeID', t: 195, p: 100 }, { n: 'TaxableTypeID', t: 195, p: 100 }, { n: 'RateTypeID', t: 195, p: 100 }, { n: 'SeasonCodeID', t: 195, p: 100 }, { n: 'DayOfWeek', t: 201, p: 0 }, { n: 'DaysOfWeek', t: 15, p: 0 }, { n: 'DayPeriod', t: 201, p: 0 }, { n: 'TimeOfDayID', t: 195, p: 100 }, { n: 'WeightUnitsCodeID', t: 195, p: 100 }, { n: 'StorageControlID', t: 195, p: 100 }, { n: 'IngredientsText', t: 21, p: 0 }, { n: 'UsageInstructions', t: 21, p: 0 }, { n: 'StoreInventoryLocationID', t: 195, p: 100 }, { n: 'TotalReceivedQuantity', t: 16, p: 0 }, { n: 'TotalSoldQuantity', t: 16, p: 0 }, { n: 'TotalDisposedQuantity', t: 16, p: 0 }, { n: 'TotalLostQuantity', t: 16, p: 0 }, { n: 'AssociatedItemCount', t: 24, p: 0 }, { n: 'IsRecordActive', t: 22, p: 0 }];

//------ Object Definition For CustomOrders -- Date: 2023-11-30-10:40 AM ------
const CustomOrdersOID = 545072;
const CustomOrdersO = [{ n: 'CustomOrderID',t: 195,p: 100 },{ n: 'StoreLocationID',t: 195,p: 100 },{ n: 'CustomerID',t: 195,p: 100 },{ n: 'CustomOrderParentID',t: 195,p: 100 },{ n: 'CreatedBy',t: 195,p: 100 },{ n: 'CustomOrderType',t: 201,p: 0 },{ n: 'RequestDateTime',t: 35,p: 0 },{ n: 'ScheduledPrepDateTime',t: 35,p: 0 },{ n: 'PickupDeliveryDateTime',t: 35,p: 0 },{ n: 'Persons',t: 120,p: 0 },{ n: 'OMUserID',t: 195,p: 100 },{ n: 'TotalTaxAmount',t: 28,p: 0 },{ n: 'TotalTax2Amount',t: 28,p: 0 },{ n: 'TotalTax3Amount',t: 28,p: 0 },{ n: 'AmountPaid',t: 28,p: 0 },{ n: 'DiscountAmount',t: 28,p: 0 },{ n: 'CreditAmountUsed',t: 28,p: 0 },{ n: 'RefundAmount',t: 16,p: 0 },{ n: 'UserName',t: 21,p: 0 },{ n: 'AmountPaidWithTip',t: 28,p: 0 },{ n: 'AddressID',t: 195,p: 100 },{ n: 'PhoneNumber',t: 21,p: 0 },{ n: 'ItemCount',t: 16,p: 0 },{ n: 'OptionCount',t: 24,p: 0 },{ n: 'OptionsPrice',t: 28,p: 0 },{ n: 'TotalQuantity',t: 16,p: 0 },{ n: 'OrderCreationDate',t: 35,p: 0 },{ n: 'OrderPaidDate',t: 35,p: 0 },{ n: 'Rating',t: 16,p: 0 },{ n: 'Persons',t: 120,p: 0 },{ n: 'OMUserID',t: 195,p: 100 },{ n: 'OrderNotes',t: 21,p: 0 },{ n: 'RefundTaxAmount',t: 28,p: 0 },{ n: 'PaymentAuthCode',t: 21,p: 0 },{ n: 'TransactionID',t: 24,p: 0 },{ n: 'UserName',t: 21,p: 0 },{ n: 'OrderSourceID',t: 195,p: 100 },{ n: 'POSCheckNumber',t: 21,p: 0 },{ n: 'ThirdPartyOrderNumber',t: 21,p: 0 },{ n: 'VerifiedDate',t: 35,p: 0 },{ n: 'LastModifiedOn',t: 35,p: 0 },{ n: 'OrderPreparationTypeID',t: 195,p: 100 },{ n: 'ReturnCycle',t: 24,p: 0 },{ n: 'CompletedReturnCycle',t: 24,p: 0 },{ n: 'SublocationID',t: 195,p: 100 },{ n: 'SeatNumber',t: 24,p: 0 },{ n: 'SeatName',t: 21,p: 0 },{ n: 'IndividualItems',t: 22,p: 0 },{ n: 'RecordProcessed',t: 22,p: 0 },{ n: 'ActiveCounted',t: 22,p: 0 },{ n: 'PaymentInProcess',t: 22,p: 0 },{ n: 'PaymentComplete',t: 22,p: 0 }];
//       Object Value Definition For CustomOrders
const COV = { 'CustomOrderID': 0,'StoreLocationID': 0,'CustomerID': 0,'CustomOrderParentID': 0,'CreatedBy': 0,'CustomOrderType': 0,'RequestDateTime': new Date(),'ScheduledPrepDateTime': new Date(),'PickupDeliveryDateTime': new Date(),'Persons': '','OMUserID': 0,'TotalTaxAmount': 0,'TotalTax2Amount': 0,'TotalTax3Amount': 0,'AmountPaid': 0,'DiscountAmount': 0,'CreditAmountUsed': 0,'RefundAmount': 0,'UserName': '','AmountPaidWithTip': 0,'AddressID': 0,'PhoneNumber': '','ItemCount': 0,'OptionCount': 0,'OptionsPrice': 0,'TotalQuantity': 0,'OrderCreationDate': new Date(),'OrderPaidDate': new Date(),'Rating': 0,'Persons': '','OMUserID': 0,'OrderNotes': '','RefundTaxAmount': 0,'PaymentAuthCode': '','TransactionID': 0,'UserName': '','OrderSourceID': 0,'POSCheckNumber': '','ThirdPartyOrderNumber': '','VerifiedDate': new Date(),'LastModifiedOn': new Date(),'OrderPreparationTypeID': 0,'ReturnCycle': 0,'CompletedReturnCycle': 0,'SublocationID': 0,'SeatNumber': 0,'SeatName': '','IndividualItems': false,'RecordProcessed': false,'ActiveCounted': false,'PaymentInProcess': false,'PaymentComplete': false };
//       Object Index Definition For CustomOrders
const COX = { 'CustomOrderID': 0,'StoreLocationID': 1,'CustomerID': 2,'CustomOrderParentID': 3,'CreatedBy': 4,'CustomOrderType': 5,'RequestDateTime': 6,'ScheduledPrepDateTime': 7,'PickupDeliveryDateTime': 8,'Persons': 9,'OMUserID': 10,'TotalTaxAmount': 11,'TotalTax2Amount': 12,'TotalTax3Amount': 13,'AmountPaid': 14,'DiscountAmount': 15,'CreditAmountUsed': 16,'RefundAmount': 17,'UserName': 18,'AmountPaidWithTip': 19,'AddressID': 20,'PhoneNumber': 21,'ItemCount': 22,'OptionCount': 23,'OptionsPrice': 24,'TotalQuantity': 25,'OrderCreationDate': 26,'OrderPaidDate': 27,'Rating': 28,'Persons': 29,'OMUserID': 30,'OrderNotes': 31,'RefundTaxAmount': 32,'PaymentAuthCode': 33,'TransactionID': 34,'UserName': 35,'OrderSourceID': 36,'POSCheckNumber': 37,'ThirdPartyOrderNumber': 38,'VerifiedDate': 39,'LastModifiedOn': 40,'OrderPreparationTypeID': 41,'ReturnCycle': 42,'CompletedReturnCycle': 43,'SublocationID': 44,'SeatNumber': 45,'SeatName': 46,'IndividualItems': 47,'RecordProcessed': 48,'ActiveCounted': 49,'PaymentInProcess': 50,'PaymentComplete': 51 };
const StorePromotionsO = [{ n: 'StorePromotionID', t: 24, p: 0 }, { n: 'StorePromotionName', t: 21, p: 0 }, { n: 'PromotionDescription', t: 21, p: 0 }, { n: 'StoreLocationID', t: 24, p: 0 }, { n: 'StoreGroupID', t: 24, p: 0 }, { n: 'StoreItemID', t: 24, p: 0 }, { n: 'ProductItemCategoryID', t: 24, p: 0 }, { n: 'ProductItemGroupID', t: 24, p: 0 }, { n: 'ProductItemTypeID', t: 24, p: 0 }, { n: 'DaysForDiscount', t: 24, p: 0 }, { n: 'DiscountAmount', t: 28, p: 0 }, { n: 'DiscountPercentage', t: 23, p: 8 }, { n: 'Price', t: 28, p: 0 }, { n: 'PromotionType', t: 201, p: 0 }, { n: 'StartDateTime', t: 35, p: 0 }, { n: 'EndDateTime', t: 35, p: 0 }, { n: 'ImageID', t: 41, p: 0 }, { n: 'PromotionIsActive', t: 22, p: 0 }];
//--------------------------------------------------------------------------------------------------------
//const StyledButton = styled(Button)`
//        color: palevioletred;
//        font-weight: bold;
//    `;    
//--- TaskBoard ------   
const tasks = cards.map((c) => ({
  id: c.id,
  title: c.title,
  description: c.description,
  status: c.status,
  priority: c.priority,
  image: c.image,
}));
const taskBrdColumns = [
  {
    id: 1,
    title: "Waiting",
    status: "new",
  },
  {
    id: 2,
    title: "In Progress",
    status: "inProgress",
  },
  {
    id: 3,
    title: "Done Orders",
    status: "ready",
  },
];
const priorities = [
  {
    priority: "Low Priority",
    color: "green",
  },
  {
    priority: "High Priority",
    color: "blue",
  },
  {
    priority: "Urgent",
    color: "orange",
  },
];
//--- Sched ------ 
//import esMessages from './es.json'; 
//loadMessages(esMessages, 'es-ES');
//import { sampleDataWithCustomSchema, displayDate, customModelFields } from './events-utc';
//load(likelySubtags, currencyData, weekData, numbers, currencies, caGregorian, dateFields, timeZoneNames);
const esMessages = {
  "scheduler": {
    "today": "Hoy",
    "allDay": "todo el dia",
    "showWorkDay": "Mostrar horas laborables",
    "showFullDay": "Mostrar d�a completo",
    "agendaViewTitle": "Agenda",
    "dayViewTitle": "D�a",
    "weekViewTitle": "Semana",
    "workWeekViewTitle": "Semana laboral",
    "monthViewTitle": "Mes"
  }
}
// Sample Data
var TaskData = [];
var DeleteOrderID = 0;
//-------------------------------------
export const customModelFields = {
  id: "TaskID",
  title: "Title",
  description: "Description",
  start: "Start",
  end: "End",
  recurrenceRule: "RecurrenceRule",
  recurrenceId: "RecurrenceID",
  recurrenceExceptions: "RecurrenceException",
};
//--------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------   
const CustomItem = ({ order }) => {
  const styles = {
    padding: 10
  }
  const content = [
    { src: 'https://www.telerik.com/kendo-react-ui/static/65786c1820120efbf7a76190d820ddee/5c11c/get-started.png', text: '<p>Get Started with KendoReact in 6 Minutes (Video)</p><p>And then after that you will be ready to go!</p><p>Seriously</p>' },
    { src: 'https://www.telerik.com/kendo-react-ui/static/a86e8b9e851a224d5419be4fdfb81e3d/5c11c/dive-into-code.png', text: 'Dive Into the Code of a Sample App' },
    { src: 'https://www.telerik.com/kendo-react-ui/static/65fd761bb5671af14bbfab842df0a13e/5c11c/training.png', text: 'Start Our Product Training Course' }
  ]
  return (
    <React.Fragment>
      <img src={content[order].src} style={{ width: '100%', height: 'auto' }} />
      {content[order].text}
    </React.Fragment>
  )
};
//----------------------------------------------------------------------------------------------

class KitchenManagement extends Component {
  //------------------------------------------------------------------------------------------------------
  constructor(props) {
    super(props);
    if (!SessionInfo.session)
      return;
    if (SessionInfo.KitchenManagement) { // Data saved for this session
      this.state = SessionInfo.KitchenManagement;
      this.loadExistingPage = true;
    }
    //------------- Edit StoreItem Grid ------------------------------
    this.enterInsertSI = this.enterInsertSI.bind(this);
    this.itemChangeSI = this.itemChangeSI.bind(this);
    this.enterEditSI = this.enterEditSI.bind(this);
    this.saveSI = this.saveSI.bind(this);
    this.cancelSI = this.cancelSI.bind(this);
    this.removeSI = this.removeSI.bind(this);
    this.StoreItemCommandCell = props => (<EditGridCommandCell {...props} edit={this.enterEditSI} remove={this.removeSI} add={this.saveSI} discard={this.removeSI} update={this.saveSI} cancel={this.cancelSI} editField='inEdit' keyField='StoreItemID' nameField='ItemDescription' />);
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------  
  state = {
    StoreLocationID: 0,
    CompanyID: 0,
    LocationID: 0,
    CurrentlyOpen: 0,
    AreaSize: 0,
    ContactID: 0,
    StoreGroupID: 0,
    TaxRate: 0,
    TaxRate2: 0,
    TaxRate3: 0,
    TaxRuleID: 0,
    TipRate1: 0,
    TipRate2: 0,
    TipRate3: 0,
    StoreAmenities: 0,
    MaximumPurchaseAmount: 0,
    StandardMarkupPercent: 0,
    ExtendedMarkupPercent: 0,
    CurrentInStoreWaitTime: 0,

    LocationTypeID: 0,
    ProvinceStateID: 0,
    CountryID: 0,
    //-------------------------------- 
    StoreItemID: 0,
    StorePromotionID: 0,
    DiscountPercentage: 0,
    ProductItemCategoryID: 0,
    ProductItemGroupID: 0,
    ProductItemTypeID: 0,
    ShelfLifeDays: 0,
    ItemPrice: 0,
    ItemStatusID: 0,
    PackagingTypeID: 0,
    PricingTypeID: 0,
    RateTypeID: 0,
    PromotionType: 0,
    //--------------------------------
    CustomOrderID: 0,
    TotalQuantity: 0,
    TotalNetWeight: 0,
    TotalPrice: 0,
    AmountOwing: 0,
    AmountPaid: 0,
    TotalAmount: 0,
    DiscountAmount: 0,
    CreditAmountUsed: 0,
    RefundAmount: 0,
    TipAmount: 0,
    TotalTaxAmount: 0,
    TotalTax2Amount: 0,
    TotalTax3Amount: 0,
    TotalDiscountAmount: 0,
    Price: 0,
    PromotionPrice: 0,
    TotalCost: 0,
    TotalTime: 0,
    StartDateTime: 0,
    EndDateTime: 0,
    OrderCreationDate: 0,
    OrderPaidDate: 0,
    PaymentMethodID: 0,
    IndividualItems: 0,
    PaymentVerifiedID: 0,
    DaysForDiscount: 0,
    PromotionIsActive: 0,
    ImageID: 0,
    //------ End of Field Values --------------------------------------------------------------------------------------------------------------------------
    string: '',

    StoreName: '',
    Description: '',
    SpecialtyList: '',
    MarketingMessage: '',
    PromotionalMessage: '',
    StoreImage: '',

    LocationName: '',
    UnitNumber: '',
    Address: '',
    CityName: '',
    PostalCode: '',
    PhoneNumber: '',
    EmailAddress: '',
    GeoLocation: '',

    FirstName: '',
    AdditionalName: '',
    LastName: '',
    AlternateName: '',
    Organization: '',
    BusinessPhone: '',
    ContractAddress: '',
    //--------------------------------  
    CustomerID: '',
    CustomOrderStatus: '',
    CustomOrderType: '',

    ItemName: '',
    ItemDescription: '',
    UPCNumber: '',
    BarcodeNumber: '',
    Comments: '',
    //--------------------------------
    PaidComment: '',
    OrderNotes: '',
    StorePromotionName: '',
    PromotionDescription: '',
    //--------------------------------
    HelpPages: [],
    showHelpDetail: false,
    showHelpListPopup: false,

    selectedTopTab: 0,
    //--------------------------------
    itemStateHasChanged: false,
    ScheduledPrepDateTime: undefined,
    SubTotalPrice: 0,

    CustomerName: "",
    isMainSearch: true,

    StoreLocations: [],
    StoreLocationsSkip: 0,
    StoreLocationsTake: 8,
    StoreLocationsCount: 0,
    //--------------------------------
    CustomOrderItems: [],
    customOrderItemsSkip: 0,
    customOrderItemsTake: 8,
    receiptFilter: { logic: "and", filters: [] },
    receiptSort: [],
    customOrderItemsCount: 0,

    PendingOrders: [],
    PendingOrdersSkip: 0,
    PendingOrdersTake: 18,
    PendingOrdersCount: 0,

    SubmittedOrders: [],
    InProgressOrders: [],

    ReadyOrders: [],
    ReadyOrdersSkip: 0,
    ReadyOrdersTake: 18,
    ReadyOrdersCount: 0,

    DeliveryOrders: [],
    DeliveryOrdersSkip: 0,
    DeliveryOrdersTake: 18,
    DeliveryOrdersCount: 0,

    CompletedOrders: [],
    CompletedOrdersSkip: 0,
    CompletedOrdersTake: 18,
    CompletedOrdersCount: 0,

    StoreAmenitiesVals: [],
    StoreAmenitiesList: [],
    StoreGroups: [],
    ProvinceStates: [],
    Currencies: [],
    ProjectTypes: [], //[{ text: 'Invoice Tracking 2', id: 1 }, { text: 'Supply-Chain 2', id: 2 }],
    Contacts: [],
    Sublocations: [],

    SchedEvents: [],

    //--------------------------------
    TilesInProgress: [],

    filter: "",
    taskBrdData: [],
    columnsData: [...taskBrdColumns],
    //--------------------------------
    ProductItemCategories: [],
    ProductItemGroups: [],
    ProductItemTypes: [],
    ItemStatusSet: [],
    PromotionTypes: [],
    PackagingTypes: [],
    PricingTypes: [],
    RateTypes: [],
    PaymentMethods: [],
    //------ Dictionary Arrays ------
    StorePromotions: [],
    StoreLocationsDict: [],
    StoreItemsDict: [],
    SchedulerData: [],
    //--
    files: [],
    UploadFile: undefined,
    ImageType: "",
    DocumentTypeID: 0,
    //--------------------------------
    LeftO: false,
    RightO: false,
    horizontalPanes: [{ size: '20%', min: '20px', collapsible: false }, { min: '300px', collapsible: false }, { size: '20%', collapsed: true, collapsible: true }], // Left, Middle, Right
    //verticalPanes: [{ min: '300px' }, { size: '50%', collapsible: true }],  // Top, Bottom   
    //horizontalSubPanes: [{ size: '50%', min: '250px', collapsible: false, collapsed: false, scrollable: false }, { min: '200px', collapsible: true, collapsed: true, scrollable: false }], // Left, Right
  };
  horizSplitOC = JSON.parse('[{"0":"[","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"size":"20%"},{"0":"{","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true}, { "collapsible": true, "collapsed": true, "resizable": true, "scrollable": true, "size": "20%" }]');
  horizSplitCC = JSON.parse('[{"0":"[","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"size":"50px"},{"0":"{","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true}, { "collapsible": true, "collapsed": true, "resizable": true, "scrollable": true, "size": "20%" }]');
  horizSplitCO = JSON.parse('[{"0":"[","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"size":"50px"},{"0":"{","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true}, { "collapsible": true, "collapsed": false, "resizable": true, "scrollable": true, "size": "20%" }]');
  horizSplitOO = JSON.parse('[{"0":"[","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"size":"20%"},{"0":"{","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true}, { "collapsible": true, "collapsed": false, "resizable": true, "scrollable": true, "size": "20%" }]');
  horizSplitCOW = JSON.parse('[{"0":"[","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"size":"50px"},{"0":"{","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true}, { "collapsible": true, "collapsed": false, "resizable": true, "scrollable": true, "size": "60%" }]');
  horizSplitOOW = JSON.parse('[{"0":"[","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"size":"20%"},{"0":"{","collapsible":false,"collapsed":false,"resizable":true,"scrollable":true}, { "collapsible": true, "collapsed": false, "resizable": true, "scrollable": true, "size": "60%" }]');

  //--------------------------------  
  styles = { padding: 10, margin: 'auto', userSelect: 'none' }
  //--------------------------------
  curTilePosition = [];
  //StoreItemsOID = 544619;
  //StorePromotionsOID = 544701;
  hasOptions = false;
  displayWarning = false;
  compUpdate = true;
  lastTab = -1;
  lastUpdate = new Date(); // Start Time

  currentTab = 0; 
  //KITCHENPANEL: 1,
  tabs = {
    KITCHENSTATION: 0,
    PENDINGORDERS: 1,
    KITCHENORDERS: 0,
    READYORDERS: 3,
    COMPLETEDORDERS: 4,
    MANAGEMENT: 5,
    SCHEDULER: 6,
    //SPREADSHEET: 7
  };
  enOrderStatus = {
    OrderOpen: 1,
    OrderPending: 2,
    OrderSubmitted: 3,
    OrderInProgress: 5,
    OrderReady: 6,
    InDelivery: 7,
    Delivered: 8,
    PickedUp: 9,
    OrderRejected: 10,
    OrderPartialPaid: 11,
    OrderPaid: 12,
    OrderReturned: 14,
    Problems: 15,
    OrderInDispute: 16,
    Abandoned: 20,
    Scrapped: 21,
  }

  vertSplitC = JSON.parse('[{"collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"min":"300px"},{"collapsible":true,"collapsed":true,"resizable":true,"scrollable":true,"size":"50%"}]');
  vertSplitO = JSON.parse('[{"collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"min":"300px"},{"collapsible":true,"collapsed":false,"resizable":true,"scrollable":true,"size":"50%"}]');
  loadExistingPage = false;
  popupAnchor = null;
  helpListPopupOffset = { left: 150, top: 60 };
  helpDetailOffset = { left: 200,top: 120 };
  clearScreen = false; 

  popupOffset = { left: 250, top: 70 };
  currentYear = new Date().getFullYear();
  parseAdjust = (eventDate) => {
    const date = new Date(eventDate);
    date.setFullYear(this.currentYear);
    return date;
  };
  taskData = undefined;
  currentOrderLocationID = -1;
  // Note - not in state  
  inRefreshTiles = false;
  fixOrderColFlag = false; // This is used when trying to move an order back in processing
  fixOrderColOrderID = 0;
  TilesPending = [];
  TilesSubmitted = [];
  TilesInProgress = [];
  TilesReady = [];
  inDrag = false;
  timerCount = 0;
  //
  PendingOrders = [];
  SubmittedOrders = [];
  InProgressOrders = [];
  ReadyOrders = [];
  CustomOrders = [];
  saveLine = undefined;
  //TaskData = baseSchedData;
  //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Mount
  async componentDidMount() {
    console.log("Mount - load KitchenManagement ");
    if (!SessionInfo.session || SessionInfo.forceLogoff === true) {
      console.log(`forceLogoff set in KitchenManagement - go to Login`);
      this.props.navigate("/Login");
    }
    let windowHt = window.innerHeight;
    let takeLinesD = (windowHt - 200) / 48.0;
    let takeLines = parseInt(takeLinesD);
    this.setState({ fullTake: takeLines });
    this.setState({ storeLocationsTake: takeLines });
    this.setState({ PendingOrdersTake: this.state.fullTake });
    this.setState({ CurrentOrdersTake: this.state.fullTake });
    this.setState({ ReadyOrdersTake: this.state.fullTake });
    this.setState({ DeliveryOrdersTake: this.state.fullTake });
    this.setState({ CompletedOrdersTake: this.state.fullTake });

    this.setState({ customersTake: takeLines });
    this.setState({ customOrderItemsTake: takeLines });
    try {
      SessionInfo.searchTitle = "Kitchen Management";
      SessionInfo.currentPage = "KitchenManagement";
      console.log("Get Locations - count: " + this.state.StoreLocationsCount);
      if (this.state.StoreLocationsCount <= 1) {
        await this.getStoreLocations();
      }
      console.log("After Get Locations - count: " + this.state.StoreLocationsCount);
      SessionInfo.currSaveFunc = this.saveRecord;
      SessionInfo.currDeleteFunc = this.deleteRecord;
      SessionInfo.currClearFunc = this.clearRecord;
      SessionInfo.currRefreshGridFunc = this.refreshGrid;
      SessionInfo.currAddGridRowFunc = undefined;
      SessionInfo.currExcelExportFunc = undefined;
      SessionInfo.currShowHelp = this.showHelp;
      SessionInfo.currExpandLPane = this.openLeftPane;
      SessionInfo.currCollapseLPane = this.closeLeftPane;
      SessionInfo.currExpandRPane = this.openRightPane;
      SessionInfo.currCollapseRPane = this.closeRightPane;
      SessionInfo.searchFunc = this.searchCurrent;
      SessionInfo.tabSelectFunc = this.selectTab;
      document.documentElement.style.setProperty('--prompt-left','130px');
      console.log("Load Existing: " + this.loadExistingPage);
      if (this.loadExistingPage === true) {
        if (this.state.StoreLocationID > 0) {
          SessionInfo.headerTitle = this.state.StoreName;
        }
        this.forceUpdate();
      }
      else {
        this.openLeftPane();
        this.initializeLocation();
      }
      if (SessionInfo.GoToTab >= 0) {
        await this.selectTab(SessionInfo.GoToTab);
        SessionInfo.GoToTab = 0;
      }
      if (this.runMonitorProcess === false) {
        this.runMonitorProcess = true;
        this.monitorProcess();
      }
      //this.runMonitorProcess = false; // For Testing only - turns off refresh  
      this.currentTab = this.tabs.KITCHENSTATION;
      //if (SessionInfo.gotoAutoPage !== '') {
      //  console.log(`Go to AutoPage: ${SessionInfo.gotoAutoPage}`);
      //  await this.selectStore("1");
      //}
      //  var TaskData2 = baseSchedData.map((dataItem) => ({
      //    ...dataItem,
      //    Start: new Date(dataItem.Start),
      //    End: new Date(dataItem.End),
      //  }));
      //  console.log("TaskData2: " + JSON.stringify(this.TaskData2));
    }
    catch (error) {
      console.log(`OrderManager Error: ${error.message}`);
    }
  }
  componentDidUpdate() {
    // On Update - from https://reactjs.org/docs/hooks-effect.html
    // Note 19Mar21 - Need to find out when this is fired
  }
  componentDidCatch() {
    // What is this?? 19Mar21
  }
  componentWillUnmount() {
    //console.log("KitchenManagement Will UnMount");
    this.runMonitorProcess = false;
    if (SessionInfo.session !== '')
      SessionInfo.KitchenManagement = this.state;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
  shouldComponentUpdate() {
    //console.log("Should Update?");
    if (this.compUpdate === true)
      return true;
    else
      return false;
  }
  //--------------- Monitor Process ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  runMonitorProcess = false;
  setTimer() {
    if (SessionInfo.loggedOn === true)
      this.timeout = setTimeout(this.monitorProcess.bind(this),500); // 1/2 second  
    else {
      console.log(`----> Stop Monitor Process`);
      this.runMonitorProcess = false;
    }
  }
  //----- Timer Process - Application Control Logic -------------------------------------------------
  async monitorProcess() {
    if (SessionInfo.forceLogoff === true || SessionInfo.loggedOn === false)
      this.props.navigate("/Login");
    else {
      if (this.runMonitorProcess === true) {
        try {
          if (DeleteOrderID > 0) { // Flag to Delete an order
            displayMessage(`Order Complete: ${DeleteOrderID}`);
            //displayMessage(`Orders: ${JSON.stringify(this.state.TilesInProgress)}`);
            //this.state.TilesInProgress.forEach(ent => console.log(`ent: ${JSON.stringify(ent.item.props.orderHdr.OrderID)}`)); // Keep this
            //let orderList = [];
            //this.state.TilesInProgress.forEach(ordr => orderList.push(ordr.item.props.orderHdr.OrderID));
            //console.log("orderList=" + orderList);
            let index = this.state.TilesInProgress.findIndex(p => p.item.props.orderHdr.OrderID === DeleteOrderID);
            console.log("index=" + index);
            if (index >= 0) {
              let TilesInProgress = this.TilesInProgress.slice();
              //updated = Object.assign({}, this.state.TilesInProgress[index]); // The row to be removed
              //console.log("updated=" + JSON.stringify(updated));
              let removed = TilesInProgress.splice(index,1);
              //console.log("removed Orders=" + JSON.stringify(removed));
              console.log("Orders AFTER update=" + JSON.stringify(TilesInProgress));
              this.TilesInProgress = TilesInProgress;
              this.setState({ TilesInProgress: this.TilesInProgress });
            }
            SessionInfo.orderIDDone = 0;
            DeleteOrderID = 0;
          }
          //console.log(`--> TIMER COUNT: ${this.timerCount}`);
          if (this.timerCount++ > 4) {
            if (this.state.selectedTopTab === this.tabs.KITCHENSTATION) {
              //console.log(`----> Monitor in KitchenStation - timeCount: ${this.timerCount}`);
              if (this.fixOrderColFlag === true) { // Code to deal with a block (possibly) dragged backward
                try {
                  console.log(`fixOrderColFlag - OrderID: ${this.fixOrderColOrderID}`);
                  //if (this.fixOrderColOrderID > 0) { // Delete fixOrderColOrderID
                  //  console.log(`----> fixOrderCol: ${this.fixOrderColFlag}, order: ${this.fixOrderColOrderID}`);
                  //  const curIx = this.TilesInProgress.findIndex(ent => ent.item.key === this.fixOrderColOrderID);
                  //  if (curIx >= 0) { // OrderID of Illegal Change (Back) - Refresh Tiles
                  //    //console.log(`----> fixOrderCol: ${JSON.stringify(this.fixOrderCol)}`);
                  //    let setOrders = this.TilesInProgress.slice();
                  //    let removedTile = setOrders.splice(curIx,1);
                  //    //console.log(`removed order: ${JSON.stringify(this.addTile)}`);
                  //    this.TilesInProgress = setOrders;
                  //    await this.setState({ TilesInProgress: this.TilesInProgress });
                  //  }
                  //}                      
                  await this.refreshTiles(this.enOrderStatus.OrderInProgress);
                  //this.timerCount = 0;
                  this.fixOrderColFlag = false;
                }
                catch (e) {
                  console.log(`error in force: ${e}`);
                }
                this.fixOrderColFlag = false;
              }
              else if (this.timerCount > 10) { // Every 5 seconds
                //console.log(`----> Monitor in KitchenStation - Refresh Tiles`);
                this.timerCount = 0;
                let currentDate = new Date();
                let time = currentDate.getHours() + ":" + currentDate.getMinutes() + ":" + currentDate.getSeconds();
                //console.log(`refresh Tiles - Time: ${time}, inDrag: ${this.inDrag}`);
                await this.refreshTiles(this.enOrderStatus.OrderInProgress); // Should get for the specific Location
                //console.log(`----> Monitor in KitchenStation - after refreshTiles`);
                //this.state.TilesInProgress.forEach(ent => console.log(`ent: ${JSON.stringify(ent.item.props.orderHdr.OrderID)}`)); // Keep this
              }
            }
          }
        } catch (error) {
          console.log(`===> ERROR - Monitor Process: ${error.message}`);
        }
        //console.log(`set Timer - Logged On: ${SessionInfo.loggedOn}, MonitorProcess: ${this.runMonitorProcess}`);
        this.setTimer();
      }
    }
  }
  //-------------------------------------------------------------------
  // Tile Item Class
  OrderTileItem = ({ orderHdr,orderItems }) => { // see BuildTiles and GetOrderItems
    console.log(`--> OrderTileItem Cons - Hdr: ${JSON.stringify(orderHdr)}`);
    //SessionInfo.orderTiles.push(this);
    const Context = createContext("default"); // Not used - for reference
    const [orderDone,setDone] = useState(false);
    const [showDetailPopup,setShowDetail] = useState(false); // Hooks
    const [showOptionPopup,setShowOption] = useState(false);
    const [optionList,setOptionList] = useState([]);
    const [optionItemName,setItemName] = useState([]);
    const [Description,setDescription] = useState([]);
    const [FullDescription,setFullDescription] = useState([]);
    const [Ingredients,setIngredients] = useState([]);
    const [SpecialInstruction,setSpecialInstruction] = useState([]);
    const [rowHeight,setRowHeight] = React.useState(18);
    //const [dialogueVisible, setDialogueVisible] = useState(false);
    const rowClick = async (event) => { // Row Click on OrderItem Line
      console.log("rowClick: " + JSON.stringify(event.dataItem));
      let OrderItemID = event.dataItem.ID;
      let CD = await CallOM("GetOrderItemIngredients",0,OrderItemID,0);
      if (!CD || !CD.d || CD.o > 9910)
        this.props.navigate("/Login");
      console.log(`Ingredients: ${JSON.stringify(CD)}`);
      let dict = CD.d; // Note - returns Dictionary<string,string>
      setSpecialInstruction(dict.Instr);
      console.log(`SpecialInstruction: ${SpecialInstruction}`);
      setIngredients(dict.Ingrd);
      CD = await CallOM("GetOrderItemOptionsListStr",0,OrderItemID,0);
      console.log(`Options: ${JSON.stringify(CD.d)}`);
      let ht = 400;
      let items = [];
      try {
        const OIOptions = CD.d.rows; //.map(dataItem => Object.assign({ selected: false }, dataItem));
        console.log(`OptionList - OIOptions: ${OIOptions.length}`);
        setOptionList(OIOptions);
        setItemName(event.dataItem.Item);
        setDescription(event.dataItem.Desc)
        setFullDescription(event.dataItem.Full)
        setIngredients(event.dataItem.Ingr)
        for (let item of OIOptions) {
          items.push({ Item: item.StoreItemID,GrpName: item.GrpName,POName: item.POName,Qty: item.Quantity,Weight: item.Weight,ID: item.ID });
          ht += 30;
          //console.log("items: " + JSON.stringify(items));
        }
      } catch (error) {
        console.log(`Failure in GetOrderItemOptions - Error: ${error.message}`);
        this.props.navigate("/Login");
      }
      console.log(`set option ht: ${ht}px`);
      document.documentElement.style.setProperty('--option-height',`${ht}px`);
      //setOptionList(items);
      for (let ix = 0; ix < SessionInfo.orderTiles.length; ix++) {
        if (SessionInfo.orderTiles[ix] !== this)
          SessionInfo.orderTiles[ix].setShowOption(false);
      }
      setShowOption(true);
    }
    const completeClick = async (event) => {
      console.log(`Confirm Done - Order # : ${orderHdr.OrderID}`);
      DeleteOrderID = orderHdr.OrderID;
      console.log(`   - DeleteOrderID # : ${DeleteOrderID}`);
      let CD = await CallOM("OrderDone",0,orderHdr.OrderID); // Update OrderStatus to Indicate Ready
      //console.log(`event: ${JSON.stringify(event.dataItem)}`);
      console.log(`Done InProgressOrders: ${JSON.stringify(this.state.InProgressOrders)}`);
      let current = this.state.InProgressOrders.findIndex(dataItem => dataItem.CustomOrderID === orderHdr.OrderID);
      console.log(`Remove Order: ${current} from InProgress`);
      if (current >= 0) {
        this.setState({ InProgressOrders: this.state.InProgressOrders.splice(current,1) });
        console.log(`After InProgressOrders: ${JSON.stringify(this.state.InProgressOrders)}`);
      }
      //// Remove the Order from the list
      if (orderDone === false) {
        setDone(true); // Hook 
      }
      else
        setDone(false);
      setShowDetail(false);
      setShowOption(false);
      await this.refreshTiles(this.enOrderStatus.OrderInProgress);
    }
    const detailClick = async (event) => {
      console.log(`Detail Click - orderTiles lth: ${SessionInfo.orderTiles.length}`);
      //console.log(event);
      for (let ix = 0; ix < SessionInfo.orderTiles.length; ix++) {
        //  if (SessionInfo.orderTiles[ix] !== this) {
        //    console.log(`hide detail for: ${ix}`);
        //    //SessionInfo.orderTiles[ix].hideDetailClick(event);
        //  }
      }
      setShowDetail(true);
      //---------- Test ---------
      //showTileDetail();
    }
    const hideDetailClick = async (event) => {
      setShowDetail(false);
    }
    const hideOptionClick = async (event) => {
      setShowOption(false);
    }
    const detailOffset = { left: 850,top: 90 };
    const optionOffset = { left: 850,top: 600 };
    let profileAnchor = undefined;
    try {
      return ( // this is the one used
        <React.Fragment>
          <div id="tileFrag">
            <span id='tileHeader'>&nbsp; Order #: {orderHdr.OrderID}</span>
            <span>&nbsp;&nbsp;</span>
            <span id='tileTime'>{orderHdr.Time}</span>
            <span>&nbsp;&nbsp;</span>
            {/*<span className='tileName'>{orderHdr.OType}</span>*/}
            <span className='tileName'>{orderHdr.OStatus}</span>
            <span>&nbsp; &nbsp; &nbsp; Items: </span>
            <span className='tileName'>{orderHdr.ItemCount}</span>
            <br />
            <span>&nbsp;&nbsp;</span>
            <Button className="tileButton" icon="launch" color="primary" onClick={detailClick}>Details</Button>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Button className="tileButton" icon="check" color="primary" onClick={completeClick}>Done</Button>
            {orderHdr.Parent == 0 ?
              <span><span>&nbsp; &nbsp; &nbsp; &nbsp; Guest: </span><span className='tileName'>{orderHdr.Name}</span></span> :
              <span><span>&nbsp; &nbsp;  Seat: </span><span className='tileName'>{orderHdr.Seat}</span><span> &nbsp; Link: </span><span className='tileName'>{orderHdr.Parent}</span></span>}
            <span>&nbsp;&nbsp;</span>
            {/*<input type="checkbox" checked={orderDone} name="taskComplete" onChange={() => setDone(!orderDone)} />*/}
            {/*<span className="editFieldLabel"> - Complete</span>*/}
            <Grid style={{ top: 5,height: '100%' }} size={"small"} resizable={false} data={orderItems}  onRowClick={rowClick} scrollable="none">
              <GridColumn field="Item" title="Menu Item" width="280px" />
              <GridColumn field="Qty" title="Qty" width="30px" cells={{ data: cellQuantity }} />
              {/*<GridColumn field="Weight" title="Weight" width="70px" />*/}
              <GridColumn field="Price" title="Price" width="66px" cells={{ data: cellCurrency }} />
              <GridColumn field="OCnt" title="Op#" width="30px" cells={{ data: cellOptions }} />
              <GridColumn field="IsItemDone" title="Done" width='38px' cells={{ data: cellBool }} />
            </Grid>
            {/* Detail Popup */}
            <Popup offset={detailOffset} show={showDetailPopup} popupClass={'popupDetail'} >
              <div id="detailPopup" ref={(div) => { profileAnchor = div; }}>
                <h3>&nbsp; Order # {orderHdr.OrderID} Detail</h3>
                <div>
                  <br />
                  <div id="div2" className="displayField">
                    <span className="editFieldLabelR">Customer</span>
                    <input value={orderHdr.Name} name="CustomerID" className="displayInput" readonly={true} />
                  </div>
                  <div id="div2" className="displayField">
                    <span className="editFieldLabelR">Seat</span>
                    <input value={orderHdr.Seat} name="SeatName" className="displayInput" readonly={true} />
                  </div>
                  <div id="div2" className="displayField">
                    <span className="editFieldLabelR">Receipt #</span>
                    <input value={orderHdr.OrderID} name="CustomOrderID" className="displayInput" readonly={true} />
                  </div>
                  <div id="div2" className="displayField">
                    <span className="editFieldLabelR">Order Type</span>
                    <input value={orderHdr.OType} name="CustomOrderType" className="displayInput" readonly={true} />
                  </div>
                  <div id="div2" className="displayField">
                    <span className="editFieldLabelR">Order Status</span>
                    <input value={orderHdr.OStatus} name="CustomOrderType" className="displayInput" readonly={true} />
                  </div>
                  <div id="div2" className="displayField">
                    <span className="editFieldLabelR">Order Time</span>
                    <input value={orderHdr.Time} className="displayInput" readonly={true} />
                  </div>
                  <br />
                  <span className='tileHeadLabel'>&nbsp; &nbsp; Notes</span>
                  <br />
                  <br />
                  <div id='div2' className='displayField'>
                    <textarea value={orderHdr.OrderNotes} name='OrderNotes' onChange={evt => this.chgFldVal(evt)} className='editTAInputFullHigh' />
                  </div>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div id='div2' className='editField'>
                    <Button id="tileButton" icon="refresh" color="primary" onClick={hideDetailClick}>Hide Detail</Button>
                  </div>
                </div>
              </div>
            </Popup>
            <Popup offset={optionOffset} show={showOptionPopup} popupClass={'popupOptions'} >
              <div id="optionPopup" ref={(div) => { profileAnchor = div; }}>
                <br/>
                <h3>&nbsp; Order Details: {optionItemName}</h3>
                {Description && Description.length > 0 ?
                  <div>
                    <span className='tileHeadLabel'>&nbsp; &nbsp; Description</span>
                    <br />
                    <div id='div2' className='editField'>
                      <textarea value={Description} name='Description' onChange={evt => this.chgFldVal(evt)} className='editTAInputFull' />
                    </div>
                  </div> : null}
                {optionList.length > 0 ?
                  <div>
                    <Grid style={{ top: 0,height: '100%' }} data={optionList} size={"medium"} resizable={false} scrollable={"none"}  onRowClick={rowClick}>
                      <GridColumn field="GrpName" title="Option" width="240px" />
                      <GridColumn field="POName" title="Choice" width="240px" />
                      {/*  <GridColumn field="Qty" title="Qty" width="50px" />*/}
                      {/*  <GridColumn field="Weight" title="Wht" width="50px" />*/}
                      {/*  <GridColumn field="Item" title="Item" width="110px" />*/}
                    </Grid>
                  </div> : <div><br /></div>}
                <br />
                {SpecialInstruction && SpecialInstruction.length > 0 ?
                  <div>
                    <span className='tileHeadLabel'>&nbsp; &nbsp; Special Instructions</span>
                    <br />
                    <div id='div2' className='editField'>
                      <textarea value={SpecialInstruction} name='SpecialInstruction' onChange={evt => this.chgFldVal(evt)} className='editTAInputFull1' />
                    </div>
                  </div> : null}
                {FullDescription && FullDescription.length > 0 ?
                  <div>
                    <span className='tileHeadLabel'>&nbsp; &nbsp; Full Description</span>
                    <br />
                    <div id='div2' className='editField'>
                      <textarea value={FullDescription} name='FullDescription' onChange={evt => this.chgFldVal(evt)} className='editTAInputFull' />
                    </div>
                  </div> : null}
                {Ingredients && Ingredients.length > 0 ?
                  <div>
                    <span className='tileHeadLabel'>&nbsp; &nbsp; Ingredients</span>
                    <br />
                    <div id='div2' className='editField'>
                      <textarea value={Ingredients} name='Ingredients' onChange={evt => this.chgFldVal(evt)} className='editTAInputFull' />
                    </div>
                  </div> : null}
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <Button id="tileButton" icon="refresh" color="primary" onClick={hideOptionClick}>Hide Options</Button>
              </div></Popup>
          </div>
        </React.Fragment>)
    } catch (error) {
      console.log(`OrderTileItem Error: ${error.message}`);
    }
  };
  //-------------------------------------------------------------------
  //--------------- Standard Page Functions ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  searchCurrent = async (search) => {
    if (!search || typeof search !== 'string' || search === 'all' || search === 'ALL')
      search = "";
    if (this.currentTab === this.tabs.PENDINGORDERS) { // Pending Orders
      displayMessage("Search for Pending Orders");
      this.getCustomOrders(search, this.enOrderStatus.OrderPending);
    }
    else if (this.currentTab === this.tabs.KITCHENSTATION) {
      displayMessage("Search Current Orders");
      this.getCustomOrders(search, this.enOrderStatus.OrderInProgress);
    }
    else if (this.currentTab === this.tabs.READYORDERS) {
      displayMessage("Search Ready Orders");
      this.getCustomOrders(search, this.enOrderStatus.OrderReady);
    }
    else if (this.currentTab === this.tabs.COMPLETEDORDERS) {
      displayMessage("Search Complete Orders");
      this.getCustomOrders(search, this.enOrderStatus.Delivered);
    }
    else { // Search What?
    }
  }
  saveRecord = async () => {
    let StoreAmenities = getAmenities(this.state.StoreAmenitiesVals);
    this.setState({ StoreAmenities });
    console.log("Save Record Tab: " + JSON.stringify(this.state.selectedTopTab));
    if (this.state.selectedTopTab === this.tabs.COMPLETEDORDERS) { // Store Item
      let propState = {};
      StoreItemsO.forEach((elem) => {
        if (elem.n in this.state) {
          propState[elem.n] = this.state[elem.n];
        }
      });
      propState["StoreAmenities"] = StoreAmenities;
      //console.log("Save Record: " + JSON.stringify(propState));
      await UpdateRow(544619, 0, undefined, propState, this.state.StoreItemID, "StoreItemID"); // Save StoreItem to OM
    }
    else if (this.state.selectedTopTab === this.tab.MANAGEMENT) { // Management - do nothing
    }
    else if (this.state.selectedTopTab === this.tabs.SCHEDULER) { // Promotions   
      //let propState = [];
      //StorePromotionsO.forEach((elem) => {
      //  if (elem.n in this.state) {
      //    let sobj = {};
      //    sobj[elem.n] = this.state[elem.n];
      //    propState.push(sobj);
      //  }
      //});  
      //let propState = {};
      //StorePromotionsO.forEach((elem) => {
      //  if (elem.n in this.state) {
      //    propState[elem.n] = this.state[elem.n];
      //  }
      //});
      //console.log("Save Promotion Record: " + JSON.stringify(propState));
      //await UpdateRow(544701, 0, undefined, propState, this.state.StorePromotionID, "StorePromotionID"); // Save StorePromotion to 
      await CallOM("UpdatePromotion", 0, this.state.StorePromotionID, 13, propState);
    }
    else {
      let propState = {};
      //console.log("Save StoreLocation");
      StoreLocationsO.forEach((elem) => {
        if (elem.n in this.state) {
          propState[elem.n] = this.state[elem.n];
        }
      });
      //console.log("Save StoreLocation: " + JSON.stringify(propState));
      await CallOM("UpdateStoreLocation", 0, this.state.StoreLocationID, 13, propState);
      //await UpdateRow(544596, 0, undefined, copyState, copyState.StoreLocationID, "StoreLocationID"); // Same StoreLocation Info to OM     
      //await UpdateRow(509178, 0, undefined, copyState, copyState.LocationID, "LocationID"); // Same StoreLocation Info to OM 
    }
    this.setItemStateChanged(false);
  }
  deleteRecord = async () => {
    let CD = await DeleteRowTry(544596, this.state.StoreLocationID);
    //console.log("Delete Msg Lvl: " + CD.x.o);
    this.setItemStateChanged(false);
  }
  clearRecord = async () => { // Note => functions do not bind their own this - if used clearRecord() - would have to bind this to the function
    //console.log("Clear Screen - state: " + JSON.stringify(this.state)); 
    let fields = [];
    fields = CustomOrdersO;
    fields.forEach((elem) => {
      let sobj = {};
      try {
        if (elem.t === 34 || elem.t === 35)
          sobj[elem.n] = new Date();
        else if (elem.t === 21 || elem.t === 22)
          sobj[elem.n] = '';
        else
          sobj[elem.n] = 0;
        this.setState(sobj);
      } catch (error) {
        console.log("Clear Promotion Field: " + elem.n + " Error: " + error.message);
      }
    });

    this.clearScreen = true;
    this.setState({ CFProjectParticipants: [] });
    this.setItemStateChanged(false);
  }
  refreshGrid = async () => { // Note => functions do not bind their own this - if used clearRecord() - would have to bind this to the function
    //console.log("Clear Screen - state: " + JSON.stringify(this.state)); 
    let fields = [];
  }
  clearTables = () => {
    this.setState({ storeLocationsCount: 0 });
    this.setState({ storeLocationsSkip: 0 });
    this.setState({ storeLocationsTake: this.state.fullTake });
    //--------------------------------
    this.setState({ PendingOrdersCount: 0 });
    this.setState({ PendingOrdersSkip: 0 });
    this.setState({ PendingOrdersTake: this.state.fullTake });

    this.setState({ CurrentOrdersCount: 0 });
    this.setState({ CurrentOrdersSkip: 0 });
    this.setState({ CurrentOrdersTake: this.state.fullTake });

    this.setState({ ReadyOrdersCount: 0 });
    this.setState({ ReadyOrdersSkip: 0 });
    this.setState({ ReadyOrdersTake: this.state.fullTake });

    this.setState({ DeliveryOrdersCount: 0 });
    this.setState({ DeliveryOrdersSkip: 0 });
    this.setState({ DeliveryOrdersTake: this.state.fullTake });

    this.setState({ CompletedOrdersCount: 0 });
    this.setState({ CompletedOrdersSkip: 0 });
    this.setState({ CompletedOrdersTake: this.state.fullTake });
    this.forceUpdate();
  }

  defaultItemType = { text: "Select Type ..." };
  defaultCFProjectControlTypeID = { text: "Select Type ..." };

  closeLeftPane = () => {
    //console.log("Close Left Pane");
    this.setState({ LeftO: false });
    if (this.state.RightO === false)
      this.setState({ horizontalPanes: this.horizSplitCC });
    else
      this.setState({ horizontalPanes: this.horizSplitCO });
    SessionInfo.setLPaneOpen = 1;
    SessionInfo.setLPaneClose = 2;
  }
  openLeftPane = () => {
    //console.log("Open Left Pane");
    this.setState({ LeftO: true });
    if (this.state.RightO === false)
      this.setState({ horizontalPanes: this.horizSplitOC });
    else
      this.setState({ horizontalPanes: this.horizSplitOO });
    SessionInfo.setLPaneClose = 1;
    SessionInfo.setLPaneOpen = 2;
  }
  closeRightPane = () => {
    //console.log("Close Right Pane");
    this.setState({ RightO: false });
    if (this.state.LeftO === false)
      this.setState({ horizontalPanes: this.horizSplitCC });
    else
      this.setState({ horizontalPanes: this.horizSplitOC });
    SessionInfo.setRPaneOpen = 1;
    SessionInfo.setRPaneClose = 2;
  }
  openRightPane = () => {
    //console.log("Open Right Pane");
    this.setState({ RightO: true });
    if (this.state.LeftO === false)
      this.setState({ horizontalPanes: this.horizSplitCO });
    else
      this.setState({ horizontalPanes: this.horizSplitOO });
    SessionInfo.setRPaneClose = 1;
    SessionInfo.setRPaneOpen = 2;
  }
  openRightPaneWide = (leftOpen) => {
    if (leftOpen === undefined)
      leftOpen = this.state.LeftO;
    //console.log(`Open Right Pane - Left: ${leftOpen}`);
    this.setState({ RightO: true });
    if (leftOpen === false)
      this.setState({ horizontalPanes: this.horizSplitCOW });
    else
      this.setState({ horizontalPanes: this.horizSplitOOW });
    SessionInfo.setRPaneClose = 1;
    SessionInfo.setRPaneOpen = 2;
  }
  //--------------- End of Standard Page Functions ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- 
  selectStore = async (storeLocation) => {
    SessionInfo.KitchenLocationID = storeLocation;
    await this.initializeLocation();
    await this.selectTab(this.tabs.KITCHENSTATION);
  }
  //--------------- Page Setup and Load Functions ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // load and update orders
  //async loadOrders(StatusID) { // see getCustomOrders
  //  if (SessionInfo.KitchenLocationID == 0) {
  //    if (this.displayWarning == false) {
  //      this.displayWarning = true;
  //      displayWarning("Select A Location First");
  //    }
  //  }
  //  else {
  //    let CD = await CallOM("GetOrders", StatusID, SessionInfo.KitchenLocationID, 2, ""); // Fetch CustomOrders based on OrderStatus
  //    console.log(`--> Load Orders (${StatusID}): ${JSON.stringify(CD.d)}`);
  //    if (CD.x.o >= 9000 && CD.x.o < 9500) {
  //      try {
  //        this.lastUpdate = new Date();
  //        if (StatusID === 2)
  //          this.setState({ PendingOrders: CD.d.rows });
  //        if (StatusID === 3)
  //          this.setState({ SubmittedOrders: CD.d.rows });
  //        else if (StatusID === 5) { // Collected Submitted, In Progress and Ready 
  //          let PendingOrders = [];
  //          let SubmittedOrders = [];
  //          let InProgressOrders = [];
  //          let ReadyOrders = [];
  //          CD.d.rows.forEach(ent => {
  //            if (ent.CustomOrderStatus === 'Order Pending')
  //              PendingOrders.push(ent);
  //            else if (ent.CustomOrderStatus === 'Order Submitted')
  //              SubmittedOrders.push(ent);
  //            else if (ent.CustomOrderStatus === 'Ready')
  //              ReadyOrders.push(ent);
  //            else
  //              InProgressOrders.push(ent);
  //          });
  //          console.log(`submitted: ${JSON.stringify(SubmittedOrders)}, inProg: ${JSON.stringify(InProgressOrders)}, ready: ${JSON.stringify(ReadyOrders)}`); 
  //          this.PendingOrders = PendingOrders.slice();
  //          this.setState({ PendingOrders });
  //          this.SubmittedOrders = SubmittedOrders.slice();
  //          this.setState({ SubmittedOrders });
  //          this.InProgressOrders = InProgressOrders.slice();
  //          this.setState({ InProgressOrders });
  //          this.ReadyOrders = ReadyOrders.slice();
  //          await this.setState({ ReadyOrders });
  //        }
  //        else if (StatusID === 6)
  //          this.setState({ ReadyOrders: CD.d.rows });
  //        else if (StatusID === 7)
  //          this.setState({ DeliveryOrders: CD.d.rows });
  //        else if (StatusID === 10)
  //          this.setState({ CompletedOrders: CD.d.rows });
  //      } catch (error) {
  //        console.log(error.message);
  //      }
  //    }
  //    else {
  //      displayError(`Unable to retrieve orders for Location: ${SessionInfo.KitchenLocationID}, Status: ${StatusID}`);
  //      this.setState({ StoreLocations: [] });
  //    }
  //  }
  //}
  getCustomOrdersStatus = async (getStatusID) => {
    console.log(`Get CustomOrdersStatus - locationID: ${SessionInfo.KitchenLocationID} StatusID: ${getStatusID}`);
    await this.getCustomOrders("",getStatusID);
  }
  getCustomOrders = async (search,getStatusID) => { // see loadOrders
    if (!search)
      search = '';
    console.log("Get CustomOrders - locationID: " + SessionInfo.KitchenLocationID);
    let CD = await CallOM("GetOrders",getStatusID,SessionInfo.KitchenLocationID,2,search); // Fetch Pending Orders 
    try {
      this.CustomOrders = CD.d.rows.slice(); //.map(dataItem => Object.assign({ selected: false }, dataItem));
      console.log(`Get CustomOrders(${getStatusID}): ${JSON.stringify(this.CustomOrders)}`);
      if (getStatusID === this.enOrderStatus.OrderPending) {
        this.PendingOrders = this.CustomOrders;
        this.setState({ PendingOrders: this.PendingOrders });
      } else if (getStatusID === this.enOrderStatus.OrderSubmitted) {
        this.SubmittedOrders = this.CustomOrders;
        this.setState({ SubmittedOrders: this.SubmittedOrders });
      } else if (getStatusID === this.enOrderStatus.OrderInProgress) {
        this.InProgressOrders = this.CustomOrders;
        this.setState({ InProgressOrders: this.InProgressOrders });
      } else if (getStatusID === this.enOrderStatus.OrderReady) {
        this.ReadyOrders = this.CustomOrders;
        this.setState({ ReadyOrders: this.ReadyOrders });
      } else if (getStatusID === 102)
        this.setState({ PickupOrders: this.CustomOrders });
      else if (getStatusID === this.enOrderStatus.InDelivery)
        this.setState({ DeliveryOrders: this.CustomOrders });
      else if (getStatusID === 100)
        this.setState({ InPaymentOrders: this.CustomOrders });
      else if (getStatusID >= 8) // Might be >= 8?  this.enOrderStatus.OrderPaid
        this.setState({ CompletedOrders: this.CustomOrders });
    } catch (error) {
      console.log(`Failure in getCustomOrders - Error: ${error.message}`);
      console.log(`CD: ${JSON.stringify(CD)}`);
    }
    //console.log(`Ready: ${JSON.stringify(this.state.ReadyOrders)}`)
  }
  async loadTasks() {
    if (SessionInfo.KitchenLocationID == 0) {
      if (this.displayWarning == false) {
        this.displayWarning = true;
        displayWarning("Select A Location First");
      }
    }
    else {
      console.log("Get Tasks -------------------------------------------------");
      let CD = await CallOM("GetTasks",0,SessionInfo.KitchenLocationID,0); // TaskList Returned for Scheduler   
      getTaskID(); // Initialize TaskID for create
      //console.log("W Tasks: " + JSON.stringify(CD.d));
      this.taskData = CD.d.rows;
      //console.log("TaskData: " + JSON.stringify(this.taskData));
      TaskData = this.taskData.map(dataItem => (
        {
          TaskID: dataItem.COTaskID,
          OwnerID: 2,
          Title: dataItem.Title,
          Description: dataItem.Description,
          Start: new Date(dataItem.StartDateTime),
          End: new Date(dataItem.EndDateTime),
          isAllDay: dataItem.isAllDay,
          RecurrenceRule: dataItem.RecurrenceRule,
          RecurrenceId: dataItem.RecurrenceID,
          RecurrenceExceptions: dataItem.RecurrenceException,
          TaskCommandID: dataItem.TaskCommandID,
          Parameters: dataItem.Parameters,
        }
      ));
      //console.log("TaskData: " + JSON.stringify(TaskData));
      this.setState({ SchedulerData: TaskData });
    }
  }
  //------------- Refresh Tile Processing ------------------------------------------------------------------------------------ 
  // Fetch the Orders for a Given Status - As Tiles
  //refreshTiles = async (getStatusID) => { // NOTE - this should work for this.OrderTileItem
  async refreshTiles(getStatusID) { // See buildTiles
    try {                             
      //console.log(`----> RefreshTiles - status: ${getStatusID}, inDrag: ${this.inDrag}`);
      if (this.inDrag === true) {
        this.inDrag = false; // This is a hack - this will wait one more cycle before refreshing tiles - need an event on drag stop (reposition only fires on actual change in position)
        return;
      }                     
      if (this.inRefreshTiles === true)
        return;
      this.inRefreshTiles = true;    
      let updates = false;
      //let curTiles = this.state.TilesInProgress.slice();
      let curTiles = this.TilesInProgress;
      //console.log(`--> Refresh TilesInProgress: ${JSON.stringify(curTiles)}`);
      let orderList = [];
      let removeList = [];
      let CD = undefined;
      let isExcept = false;
      let curIx = -1;
      this.TilesInProgress.forEach(ent => orderList.push(Number(ent.item.props.orderHdr.OrderID)));
      //console.log(`-----> existing orderList=${orderList}`);  
      //console.log(this.TilesInProgress);
      let orderCount = orderList.length - 1; // start after current count
      //----------------- Deletions (Removals) First - then Status Changes - and then Additions -------------------------------------------------------------
      if (orderCount >= 0) { // Orders Have Been loaded - look for deletions and additions 
        let removed = false;
        if (this.fixOrderColFlag === true) { // Code to deal with a block dragged backward
          console.log(`refresh fixOrderColFlag - OrderID: ${this.fixOrderColOrderID}`);
          if (this.fixOrderColOrderID > 0) { // Delete fixOrderColOrderID - NOTE - This is flag to indicate an attempt to move a block backwards in Status    
            updates = true;
            console.log(`----> fixOrderCol: ${this.fixOrderColFlag}, order: ${this.fixOrderColOrderID}`);
            curIx = this.TilesInProgress.findIndex(ent => ent.item.key === this.fixOrderColOrderID);
            if (curIx >= 0) { // OrderID of Illegal Change (Back) - Refresh Tiles
              //console.log(`----> fixOrderCol: ${JSON.stringify(this.fixOrderCol)}`);
              let removedTile = this.TilesInProgress.splice(curIx,1);
              curIx = orderList.indexOf(Number(this.fixOrderColOrderID));
              console.log(`orderlist key: ${this.fixOrderColOrderID}, curIx: ${curIx}`);
              if (curIx >= 0) { // Remove from current list - will be picked up by Get Except
                let remOrder = orderList.splice(curIx,1);
                console.log(`remOrder: ${remOrder}`);
                removed = true;
              }
              //console.log(`removed order: ${JSON.stringify(this.addTile)}`);
            }
            this.fixOrderColFlag = false;
            removeList.push(this.fixOrderColOrderID);
            this.fixOrderColOrderID = 0;
          }
        } else { // Normal situation - Look for deleted orders or orders moved past current status range
          CD = await CallOM("GetOrdersRemoved",getStatusID,SessionInfo.KitchenLocationID,CTYP.INTA,orderList); // Get List of Orders removed via status change 
          if (CD && CD.d.rows) {
            let removeCount = CD.d.rows.length;
            if (removeCount > 0) {
              console.log(`CustomOrders Removed-cnt:${removeCount} status: ${getStatusID}: ${JSON.stringify(CD.d.rows)}`);
              for (let ix = 0; ix < removeCount; ix++) {
                updates = true;
                let orderID = Number(CD.d.rows[ix].CustomOrderID);
                console.log(`Remove OrderID: ${orderID}`);
                //curIx = this.TilesInProgress.findIndex(ent => console.log(`Orders: ${ent.item.props.orderHdr.OrderID}`));
                curIx = this.TilesInProgress.findIndex(ent => Number(ent.item.props.orderHdr.OrderID) == orderID);
                if (curIx >= 0) {
                  let data = this.TilesInProgress.splice(curIx,1);
                  //console.log(`---> Removed order: ${JSON.stringify(data)}`);
                  curIx = orderList.indexOf(Number(this.orderID));
                  if (curIx >= 0) {
                    let remOrder = orderList.splice(curIx,1);
                    removed = true;
                  }
                }
              }
            }
          }
        }
        //if (removed === true)
        //  return; // For Testing
        // Now look for Changes in the current Orders   
        //CD = await CallOMT("GetCurrentOrdersUpdated",CTYP.INT,getStatusID,CTYP.INT,SessionInfo.KitchenLocationID,CTYP.DATE,this.lastUpdate,CTYP.INTA,orderList); // Get List of Orders removed via status change 
        //if (CD && CD.d.rows) {
        //  let removeCount = CD.d.rows.length;
        //  if (removeCount > 0) {
        //    console.log(`====> CURRENT Orders Updated-cnt:${removeCount} status: ${getStatusID}: ${JSON.stringify(CD.d.rows)}`);
        //    for (let ix = 0; ix < removeCount; ix++) {
        //      updates = true;
        //      let orderID = Number(CD.d.rows[ix].CustomOrderID);
        //      removeList.push(this.orderID);
        //      console.log(`Remove OrderID: ${orderID}`);
        //      //curIx = this.TilesInProgress.findIndex(ent => console.log(`Orders: ${ent.item.props.orderHdr.OrderID}`));
        //      curIx = this.TilesInProgress.findIndex(ent => Number(ent.item.props.orderHdr.OrderID) == orderID);
        //      if (curIx >= 0) {
        //        let data = this.TilesInProgress.splice(curIx,1);
        //        console.log(`---> Removed (2) order: ${JSON.stringify(data)}`);
        //        curIx = orderList.indexOf(Number(this.orderID));
        //        if (curIx >= 0) {
        //          let remOrder = orderList.splice(curIx,1);
        //          removed = true;
        //        }
        //      }
        //    }
        //  }
        //}
        //if (updates === true) {
        //  //this.TilesInProgress = curTiles.slice();
        //  this.setState({ TilesInProgress: this.TilesInProgress });
        //  console.log(`=====> Removed Orders - orderList=${removeList}`);
        //}
        //if (removed === true)
        //  return; // For Testing
        if (removed === true && removeList.length > 0) {
          //console.log(`-----> get removed Orders - orderList=${removeList}, status: ${getStatusID}`);
          CD = await CallOM("GetOrdersInList",getStatusID,SessionInfo.KitchenLocationID,CTYP.INTA,removeList); // Fetch Only New Orders 
        } else { // No Orders Removed - so Now fetch any new Orders that have been added
          //console.log(`-----> get except Orders - orderList=${orderList}, status: ${getStatusID}`);
          CD = await CallOM("GetOrdersExcept",getStatusID,SessionInfo.KitchenLocationID,CTYP.INTA,orderList); // Fetch Only New Orders 
        }
        isExcept = true;
      } else { // There are no current orders - so fetch all orders -- Load New - see loadOrders --------------------------------------    
        //console.log(`-----> get Orders - status: ${getStatusID}`);
        CD = await CallOM("GetOrders",getStatusID,SessionInfo.KitchenLocationID,CTYP.STR,""); // Fetch CustomOrders based on OrderStatus - InProgress - so Submitted through to Ready
      }
      //console.log(`GetOrders - in RefreshTiles - Except: ${isExcept} Return: ${JSON.stringify(CD)}`);
      //----------------- Process the Orders Returned - New or Additions -------------------------------------------------------------
      if (CD && CD.d) {
        if (CD.o > 9910)
          this.props.navigate("/Login");
        let newCustomOrders = CD.d.rows; //.map(dataItem => Object.assign({ selected: false }, dataItem));
        if (newCustomOrders.length > 0) { //---- Note - only shows NEW orders - 21Aug23 - need to remove Orders when Paid
          let addCount = newCustomOrders.length;
          if (addCount > 0) {
            //console.log(`----> New CustomOrders For(${getStatusID}): ${JSON.stringify(newCustomOrders)}`);
            for (let ix = 0; ix < addCount; ix++) {
              updates = true;
              let ordr = newCustomOrders[ix];
              //console.log(`Custom (${ix}) Order: ${JSON.stringify(ordr)}`);
              let CustOrderID = ordr.CustomOrderID;
              let PrepTime = new Date(ordr.ScheduledPrepDateTime);
              let header = {
                OrderID: ordr.CustomOrderID,Time: PrepTime.toLocaleTimeString(navigator.language,{ hour: '2-digit',minute: '2-digit' }),Name: ordr.CustomerID,OType: ordr.CustomOrderType,ItemCount: ordr.ItemCount,OStatus: ordr.CustomOrderStatus,Seat: ordr.SeatName,Parent: ordr.CustomOrderParentID
              }; // 11:03   
              let items = [];
              let rowSpan = 0;
              let column = 0;
              //console.log(`==> GetOrderItems - inDrag: ${this.inDrag}`);
              let CD = await CallOM("GetOrderItems",0,CustOrderID,0); // Order Item Line
              if (!CD.d) {
                console.log(`Unknown CustOrderID: ${CustOrderID}`);
              }
              else { // OrderItems Retrieved
                //console.log(` Order: ${CustOrderID} Items: ${JSON.stringify(CD.d)}`);
                try {
                  const CustomOrderItems = CD.d.rows; //.map(dataItem => Object.assign({ selected: false }, dataItem));
                  console.log(" Order Items Count: " + CustomOrderItems.length);
                  for (let item of CustomOrderItems) {
                    items.push({ Item: item.StoreItem,Qty: item.Quantity,Price: item.Price,Weight: item.Weight,OCnt: item.OptionCount,ID: item.ID,IsItemDone: item.IsItemDone });
                  }
                  //console.log(`Order: ${CustOrderID}, items: ${JSON.stringify(items)}`);
                } catch (error) {
                  console.log("Failure in getCustomOrderItems - Error: " + error.message);
                }
                //----------------------------------------
                let rowper = parseInt(items.length / 2);
                rowSpan = 2 + rowper;
                console.log(`-----> items: ${items.length}, rowper: ${rowper}, rowSpan: ${rowSpan}`);
                if (getStatusID == this.enOrderStatus.OrderInProgress) { // Columns based on processing status - state 
                  let statusID = this.enOrderStatus.OrderInProgress; // Default
                  console.log(`add order - status: ${ordr.CustomOrderStatus}`);
                  if (ordr.CustomOrderStatus === 'Order Pending' || ordr.CustomOrderStatus === 'Order Submitted')
                    statusID = this.enOrderStatus.OrderSubmitted;
                  else if (ordr.CustomOrderStatus === 'Ready')
                    statusID = this.enOrderStatus.OrderReady;
                  if (statusID === this.enOrderStatus.OrderPending || statusID === this.enOrderStatus.OrderSubmitted) { // Pending // Accepted
                    column = 1;
                  } else if (statusID === this.enOrderStatus.OrderInProgress) { //--------------------------------------------------
                    column = 2; // Note - add 'In Progress' to second column
                  } else if (statusID === this.enOrderStatus.OrderReady) { //--------------------------------------------------
                    column = 3; // Note - add Ready to third column 
                  }
                }
                orderCount++;
                console.log(`header: ${JSON.stringify(header)}`);
                //console.log(`items: ${JSON.stringify(items)}`);
                //console.log(`order: ${orderCount}, rowSpan: ${rowSpan}, column: ${column},`);
                let line = { // NOTE - this only works if the function is declared as a NORMAL function not LAMBDA - which makes no sense since 'this' should not work??!
                  defaultPosition: { order: orderCount,rowSpan: rowSpan,colSpan: 1,col: column },item: <this.OrderTileItem key={CustOrderID} orderHdr={header} orderItems={items} />
                };
                //console.log(`line: ${JSON.stringify(line)}`);
                this.TilesInProgress.push(line);
              }
            }
          }
        }
      }
      //----------------- Look for Updates to Existing Orders -------------------------------------------------------------
      orderList = [];
      //console.log(`Push Orders in Refresh - curTiles lth: ${curTiles.length}`);
      this.TilesInProgress.forEach(ent => orderList.push(ent.item.props.orderHdr.OrderID)); // Get Current List of Orders from curTiles
      CD = await CallOM("GetOrdersUpdated",getStatusID,SessionInfo.KitchenLocationID,CTYP.DATE,this.lastUpdate); // Get List of Orders removed via status change  
      if (CD && CD.d) {
        if (CD.o > 9910)
          this.props.navigate("/Login");
        let updatedCustomOrders = CD.d.rows;
        let updateCount = updatedCustomOrders.length;
        console.log(`OrdersUpdated - ${updateCount} - last update: ${this.lastUpdate}`);
        if (updateCount > 0) {
          //this.runMonitorProcess = false; // NOTE - FOR DEBUG - Turnoff Monitor
          //console.log(`CustomOrders To Update - Status: ${getStatusID}): ${JSON.stringify(CD.d.rows)}, UpdateTime: ${this.lastUpdate}`);
          this.lastUpdate = new Date();
          let removed = false; // for testing
          for (let ix = 0; ix < updateCount; ix++) {
            updates = true;
            let orderID = updatedCustomOrders[ix].CustomOrderID;
            //console.log(`CustomOrders To Update - Status: ${getStatusID}, remove OrderID: ${orderID}`);
            const current = this.TilesInProgress.findIndex(ent => ent.item.props.orderHdr.OrderID === orderID);
            if (current >= 0) { // Remove the Updated Order
              let data = this.TilesInProgress.splice(current,1);
              //console.log(`removed Updated order: ${JSON.stringify(data)}`);
              removed = true;
            }
          }
          if (removed === true) {
            await this.setState({ TilesInProgress: this.TilesInProgress });
          }
          //-------------------------------------------
          //console.log(`---> updateCount: ${updateCount}`);
          for (let ix = 0; ix < updateCount; ix++) {
            updates = true;
            //if (removed === true)
            //  continue; // for testing
            let ordr = updatedCustomOrders[ix];
            //console.log(`Custom (${ix}) Order: ${JSON.stringify(ordr)}`);
            let CustOrderID = ordr.CustomOrderID;
            //console.log(`Add Back CustomOrder (${ix}) Order: ${CustOrderID}`);
            let PrepTime = new Date(ordr.ScheduledPrepDateTime);
            let header = { OrderID: ordr.CustomOrderID,Time: PrepTime.toLocaleTimeString(navigator.language,{ hour: '2-digit',minute: '2-digit' }),Name: ordr.CustomerID,OType: ordr.CustomOrderType,ItemCount: ordr.ItemCount,OStatus: ordr.CustomOrderStatus };
            let items = [];
            let rowSpan = 0;
            let column = 0;
            //console.log(`==> GetOrderItems-2 - inDrag: ${this.inDrag}`);
            let CD = await CallOM("GetOrderItems",0,CustOrderID,0); // Get the CURRENT OrderItems
            if (!CD.d) {
              console.error(`Unknown CustOrderID: ${CustOrderID}`);
            }
            else {
              //console.log(" Order Items: " + JSON.stringify(CD.d));
              try {
                const CustomOrderItems = CD.d.rows; //.map(dataItem => Object.assign({ selected: false }, dataItem));
                console.log(" Order Items Count: " + CustomOrderItems.length);
                for (let item of CustomOrderItems) {
                  items.push({ Item: item.StoreItem,Qty: item.Quantity,Price: item.Price,Weight: item.Weight,OCnt: item.OptionCount,ID: item.ID,IsItemDone: item.IsItemDone });
                }
                //console.log("items: " + JSON.stringify(items));
              } catch (error) {
                console.log("Failure in getCustomOrderItems - Error: " + error.message);
              }
              //---------------------------------------- 
              let rowper = parseInt(items.length / 2);
              rowSpan = 2 + rowper;
              //console.log(`---> items: ${items.length}, rowper: ${rowper}, rowSpan: ${rowSpan}`);
              if (getStatusID == this.enOrderStatus.OrderInProgress) { // Columns based on processing status - state 
                let statusID = this.enOrderStatus.OrderInProgress;
                if (ordr.CustomOrderStatus === 'Order Pending' || ordr.CustomOrderStatus === 'Order Submitted')
                  statusID = this.enOrderStatus.OrderSubmitted;
                else if (ordr.CustomOrderStatus === 'Ready')
                  statusID = this.enOrderStatus.OrderReady;
                if (statusID === this.enOrderStatus.OrderPending || statusID === this.enOrderStatus.OrderSubmitted) { // Pending // Accepted
                  column = 1;
                } else if (statusID === this.enOrderStatus.OrderInProgress) { //--------------------------------------------------
                  column = 2; // Note - add 'In Progress' to second column
                } else if (statusID === this.enOrderStatus.OrderReady) { //--------------------------------------------------
                  column = 3; // Note - add Ready to third column 
                }
              }
              orderCount++;
              let line = { // NOTE - this only works if the function is declared as a NORMAL function not LAMBDA - which makes no sense since 'this' should not work??!
                defaultPosition: { order: orderCount,rowSpan: rowSpan,colSpan: 1,col: column },item: <this.OrderTileItem key={CustOrderID} orderHdr={header} orderItems={items} />
              };
              this.curTilePosition.push({ key: CustOrderID,order: orderCount,rowSpan: rowSpan,colSpan: 1,col: column });
              this.TilesInProgress.push(line);
            }
          }
        }
      }
      if (updates === true) { // There have been changes to Tiles - TilesInProgress needs to be updated
        // Sample: set TilesInProgress Updated: {"x":{"s":"C32enDIZSfHy0m5Lym6BSDAzA","q":100046,"t":5,"k":1,"i":0,"o":9001,"y":15,"p":0,"f":"","m":""},"d":{"rows":[{"CustomOrderID":3694,"CustomerID":": ","CustomOrderStatus":"Order In Progress","RequestDateTime":null,"ScheduledPrepDateTime":"2023-01-23T17:06:51.9194413","OrderPaidDate":null,"TotalPrice":41.75,"TipAmount":0,"ItemCount":5,"CustomOrderType":"Order In Store","OrderNotes":"","inEdit":false}]}}
        //console.log(`Update TilesInProgress: ${JSON.stringify(this.TilesInProgress)}`);
        // NOTE - curTiles needs to be set before this  
        if (getStatusID == this.enOrderStatus.OrderInProgress) { // Columns based on processing status - state 
          //this.TilesInProgress = curTiles.slice();
          this.setState({ TilesInProgress: this.TilesInProgress }); // Update the TilesInProgress with additions and deletions for OrderInProgress - that includes Submitted and Ready
        }
        this.curTilePosition = []; // Initialize Current Positions - for comparison on Change
        for (let ix = 0; ix < this.TilesInProgress.length; ix++) { // Save all positions - note currentOrders is in the same array position as the event array
          this.curTilePosition.push({ key: this.TilesInProgress[ix].item.key,order: this.TilesInProgress[ix].defaultPosition.order,rowSpan: this.TilesInProgress[ix].defaultPosition.rowSpan,colSpan: 1,col: this.TilesInProgress[ix].defaultPosition.col });
        }
        //console.log(`refreshTile - curTilePosition: ${JSON.stringify(this.curTilePosition)}`);
      }
    } catch (error) {
      console.log(`**** Failure in refreshTiles - Error: ${error.message}`);
      await OMTrace(2,`Failure in refreshTiles - Error: ${error.message}`);
      this.props.navigate("/Login");
    } finally {
      this.inRefreshTiles = false;
    }
  }     
  // ----------------- Not Currently Used - For Taskbar loading - Not Complete Logic ---------------------------
  // TaskBoard Tasks
  //async refreshTasks() {
  //  console.log(`refreshTasks`);
  //  let updates = false;
  //  let curTasks = this.state.taskBrdData.slice();
  //  console.log(`curTasks: ${JSON.stringify(curTasks)}`);
  //  let orderList = [];
  //  try {
  //    curTasks.forEach(ent => console.log(`Task Ent: ${JSON.stringify(ent)}`));
  //    curTasks.forEach(ent => orderList.push(ent.id));
  //    console.log(`-----> existing orderList=${orderList}`);
  //    let orderCount = orderList.length - 1; // start after current count
  //    let CD = undefined;
  //    let isExcept = false;
  //    if (orderCount >= 0 && 1 === 0) {
  //      CD = await CallOM("GetOrdersRemoved",0,SessionInfo.KitchenLocationID,CTYP.INTA,orderList); // Get List of Orders removed via status change 
  //      if (CD && CD.d.rows) {
  //        let removeCount = CD.d.rows.length;
  //        if (removeCount > 0) {
  //          console.log(`CustomOrders Removed: ${JSON.stringify(CD.d.rows)}`);
  //          for (let ix = 0; ix < removeCount; ix++) {
  //            updates = true;
  //            let orderID = CD.d.rows[ix];
  //            const current = curTasks.findIndex(ent => ent.id === orderID);
  //            if (current >= 0) {
  //              let data = curTasks.splice(current,1);
  //              console.log(`removed order: ${JSON.stringify(data)}`);
  //            }
  //          }
  //        }
  //      }
  //      CD = await CallOM("GetOrdersTBExcept",0,SessionInfo.KitchenLocationID,CTYP.INTA,orderList); // Fetch Only New Orders 
  //      isExcept = true;
  //    } else { // There are no current orders - so fetch all orders
  //      CD = await CallOM("GetOrdersTB",0,SessionInfo.KitchenLocationID,CTYP.STR,""); // Fetch CustomOrders based on OrderStatus
  //    }
  //    console.log(`GetOrdersExcept Return: ${JSON.stringify(CD)}`);
  //    if (CD && CD.d.rows) {
  //      let newCustomOrders = CD.d.rows; //.map(dataItem => Object.assign({ selected: false }, dataItem));
  //      if (newCustomOrders.length > 0) { //----------------------------------------
  //        let addCount = newCustomOrders.length;
  //        if (addCount > 0) {
  //          console.log(`----> New CustomOrders: ${JSON.stringify(newCustomOrders)}`);
  //          for (let ix = 0; ix < addCount; ix++) {
  //            updates = true;
  //            let ordr = newCustomOrders[ix];
  //            console.log(`Custom (${ix}) Order: ${JSON.stringify(ordr)}`);
  //            let CustOrderID = ordr.CustomOrderID;
  //            let PrepTime = new Date(ordr.ScheduledPrepDateTime);
  //            let header = {
  //              OrderID: ordr.CustomOrderID,Time: PrepTime.toLocaleTimeString(navigator.language,{ hour: '2-digit',minute: '2-digit' }),Name: ordr.CustomerID,OType: ordr.CustomOrderType,ItemCount: ordr.ItemCount
  //            }; // 11:03   
  //            if (1 === 0) {
  //              let items = [];
  //              let rowSpan = 0;
  //              let column = 0;
  //              let CD = await CallOM("GetOrderItems",0,CustOrderID,0); // Order Item Line
  //              if (!CD.d) {
  //                console.log(`Unknown CustOrderID: ${CustOrderID}`);
  //              }
  //              else { // OrderItems Retrieved
  //                console.log(" Order Items: " + JSON.stringify(CD.d));
  //                try {
  //                  const CustomOrderItems = CD.d.rows; //.map(dataItem => Object.assign({ selected: false }, dataItem));
  //                  console.log(" Order Items Count: " + CustomOrderItems.length);
  //                  for (let item of CustomOrderItems) {
  //                    items.push({ Item: item.StoreItem,Qty: item.Quantity,Price: item.Price,Weight: item.Weight,OCnt: item.OptionCount,ID: item.ID,IsItemDone: item.IsItemDone });
  //                  }
  //                  //console.log("items: " + JSON.stringify(items));
  //                } catch (error) {
  //                  console.log("Failure in getCustomOrderItems - Error: " + error.message);
  //                  this.props.navigate("/Login");
  //                }
  //                //----------------------------------------
  //                rowSpan = 1;
  //                if (items.length >= 3) {
  //                  rowSpan = 2;
  //                  if (items.length >= 7)
  //                    rowSpan = 3;
  //                }
  //                column = 2;
  //                orderCount++;
  //                console.log(`header: ${JSON.stringify(header)}`);
  //                //console.log(`items: ${JSON.stringify(items)}`);
  //                console.log(`order: ${orderCount}, rowSpan: ${rowSpan}, column: ${column},`);
  //                let line = { // NOTE - this only works if the function is declared as a NORMAL function not LAMBDA - which makes no sense since 'this' should not work??!
  //                  defaultPosition: { order: orderCount,rowSpan: rowSpan,colSpan: 1,col: column },item: <this.OrderTileItem orderHdr={header} orderItems={items} />
  //                };
  //                console.log(`line: ${JSON.stringify(line)}`);
  //                //if (this.saveLine) {
  //                //  console.log(`saveline: ${JSON.stringify(this.saveLine)}`);
  //                //  curTiles.push(this.saveLine);
  //                //} else
  //                curTiles.push(line);
  //              }
  //            }
  //            //--------------------------------------------------------------------------
  //            if (newCustomOrders.length > 0) { //----------------------------------------
  //              let taskList = [];
  //              // Process New Orders for TaskBar
  //              if (isExcept === true)
  //                taskList = this.state.taskBrdData.slice(); // Existing Taks
  //              let addCount = newCustomOrders.length;
  //              if (addCount > 0) {
  //                console.log(`===> TaskBar CustomOrders: ${JSON.stringify(newCustomOrders)}`);
  //                for (let ix = 0; ix < addCount; ix++) {
  //                  let taskCard = {
  //                    id: ordr.CustomOrderID,title: PrepTime.toLocaleTimeString(navigator.language,{ hour: '2-digit',minute: '2-digit' }),description: ordr.CustomerName,status: ordr.Status,priority: { color: "blue",priority: "High Priority" }
  //                  }; //
  //                  taskList.push(taskCard);
  //                }
  //                this.setState({ taskBrdData: taskList });
  //              }
  //              console.log(`taskList: ${JSON.stringify(taskList)}`);
  //            }
  //          }
  //        }
  //      }
  //    }
  //    if (1 === 0) {
  //      orderList = [];
  //      //console.log(`Push Orders in Refresh - curTiles lth: ${curTiles.length}`);
  //      curTiles.forEach(ent => orderList.push(ent.item.props.orderHdr.OrderID)); // Get Current List of Orders from curTiles
  //      CD = await CallOM("GetOrdersUpdated",0,SessionInfo.KitchenLocationID,CTYP.DATE,this.lastUpdate); // Get List of Orders removed via status change 
  //      if (CD && CD.d.rows) {
  //        let updatedCustomOrders = CD.d.rows;
  //        let updateCount = updatedCustomOrders.length;
  //        if (updateCount > 0) {
  //          console.log(`CustomOrders To Update: ${JSON.stringify(CD.d.rows)}, UpdateTime: ${this.lastUpdate}`);
  //          this.lastUpdate = new Date();
  //          for (let ix = 0; ix < updateCount; ix++) {
  //            updates = true;
  //            let orderID = updatedCustomOrders[ix].CustomOrderID;
  //            const current = curTiles.findIndex(ent => ent.item.props.orderHdr.OrderID === orderID);
  //            if (current >= 0) {
  //              let data = curTiles.splice(current,1);
  //              console.log(`removed order: ${JSON.stringify(data)}`);
  //            }
  //          }
  //          for (let ix = 0; ix < updateCount; ix++) {
  //            updates = true;
  //            let ordr = updatedCustomOrders[ix];
  //            console.log(`Custom (${ix}) Order: ${JSON.stringify(ordr)}`);
  //            let CustOrderID = ordr.CustomOrderID;
  //            let PrepTime = new Date(ordr.ScheduledPrepDateTime);
  //            let header = { OrderID: ordr.CustomOrderID,Time: PrepTime.toLocaleTimeString(navigator.language,{ hour: '2-digit',minute: '2-digit' }),Name: ordr.CustomerID,OType: ordr.CustomOrderType,ItemCount: ordr.ItemCount };
  //            let items = [];
  //            let rowSpan = 0;
  //            let column = 0;
  //            let CD = await CallOM("GetOrderItems",0,CustOrderID,0); // Order Item Line
  //            if (!CD.d) {
  //              console.error(`Unknown CustOrderID: ${CustOrderID}`);
  //            }
  //            else {
  //              //console.log(" Order Items: " + JSON.stringify(CD.d));
  //              try {
  //                const CustomOrderItems = CD.d.rows; //.map(dataItem => Object.assign({ selected: false }, dataItem));
  //                console.log(" Order Items Count: " + CustomOrderItems.length);
  //                for (let item of CustomOrderItems) {
  //                  items.push({ Item: item.StoreItem,Qty: item.Quantity,Price: item.Price,Weight: item.Weight,OCnt: item.OptionCount,ID: item.ID,IsItemDone: item.IsItemDone });
  //                }
  //                //console.log("items: " + JSON.stringify(items));
  //              } catch (error) {
  //                console.log("Failure in getCustomOrderItems - Error: " + error.message);
  //                this.props.navigate("/Login");
  //              }
  //              //----------------------------------------
  //              rowSpan = 1;
  //              if (items.length >= 3) {
  //                rowSpan = 2;
  //                if (items.length >= 7)
  //                  rowSpan = 3;
  //              }
  //              column = 2;
  //              orderCount++;
  //              let line = { // NOTE - this only works if the function is declared as a NORMAL function not LAMBDA - which makes no sense since 'this' should not work??!
  //                defaultPosition: { order: orderCount,rowSpan: rowSpan,colSpan: 1,col: column },item: <this.OrderTileItem orderHdr={header} orderItems={items} />
  //              };
  //              this.curTilePosition.push({ key: CustOrderID,order: orderCount,rowSpan: rowSpan,colSpan: 1,col: column });
  //              curTiles.push(line);
  //            }
  //          }
  //        }
  //      }
  //      if (updates === true) {
  //        // Sample: set TilesInProgress Updated: {"x":{"s":"C32enDIZSfHy0m5Lym6BSDAzA","q":100046,"t":5,"k":1,"i":0,"o":9001,"y":15,"p":0,"f":"","m":""},"d":{"rows":[{"CustomOrderID":3694,"CustomerID":": ","CustomOrderStatus":"Order In Progress","RequestDateTime":null,"ScheduledPrepDateTime":"2023-01-23T17:06:51.9194413","OrderPaidDate":null,"TotalPrice":41.75,"TipAmount":0,"ItemCount":5,"CustomOrderType":"Order In Store","OrderNotes":"","inEdit":false}]}}
  //        //console.log(`Update TilesInProgress: ${JSON.stringify(curTiles)}`);
  //        // NOTE - curTiles needs to be set before this
  //        this.setState({ TilesInProgress: curTiles });
  //      }
  //    }
  //  } catch (error) {
  //    console.log(`Failure in refreshTasks - Error: ${error.message}`);
  //    this.props.navigate("/Login");
  //  }
  //}
  //addTileLine = (orderCount, rowSpan, column, header, items, custOrderID) => {
  //  let line = {
  //    defaultPosition: { order: orderCount, rowSpan: rowSpan, colSpan: 1, col: column }, item: <this.OrderTileItem orderHdr={header} orderItems={items} key={custOrderID} />
  //  };
  //  return line;
  //}
  //---------- Scheduler Events ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  async loadEvents(eventStatus) {
    console.log(`Start Date: ${SessionInfo.CurrentSchedDate}`);
    let CD = await CallOM("GetEvents", eventStatus, SessionInfo.KitchenLocationID, 2, SessionInfo.CurrentSchedDate); // Fetch CustomOrders based on OrderStatus
    console.log("Load Events: " + JSON.stringify(CD.d));
    if (CD.x.o >= 9000 && CD.x.o < 9500) {
      try {
        this.setState({ SchedEvents: CD.d.rows });
      } catch (error) {
        console.log(`loadEvent Error: ${error.message}`);
        this.props.navigate("/Login");
      }
    }
    else {
      displayError(`Unable to retrieve Schedule for Location: ${SessionInfo.KitchenLocationID}, Status: ${eventStatus}`);
      this.setState({ StoreLocations: [] });
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  testReposition = (event) => {
    //console.log(`testRepostion: ${JSON.stringify(event.target)}`);
    //console.log(event.target);
    let str = event.target.innerText.toString(); 
    let idx = str.indexOf('Order #: ');
    let numStr = str.substring(idx + 9,idx + 15); // string between start and end
    let num = Number(numStr);                   
    //console.log(`testRepostion: ${str}`);
    idx = str.indexOf('Ready'); // Block move if Status is Ready
    console.log(`testRepostion: '${numStr}' ${num}, ready idx: ${idx}`);
    //console.log(event);
    if (idx > 0) {
      this.inDrag = false;
      return true; // return true prevents dragging
    } else { // Drag is allowed
      this.inDrag = true;
      return false;
    }
  }
  repositionCurrent = async (event) => { // Note that this is triggered if a successful move to another column
    this.inDrag = true;
    try { // Move Tile to a different column - event.value shows all the tiles - no idea which one was just moved                    
      console.log("repositionCurrent value: " + JSON.stringify(event.value)); // + " target: " + JSON.stringify(event.target.props.items.item.key));  
      //console.log(event); 
      let cnt = event.value.length;
      //let currentOrders = this.state.TilesInProgress.slice();
      let currentOrders = this.TilesInProgress.slice();
      //console.log("currentTile: " + JSON.stringify(currentOrders)); // this is the original default positions
      let curTilePosition = [];
      let changeOrder = 0;
      let oldColumn = -1;
      let newColumn = -1;
      let illegalChange = false;
      let validChange = false;
      for (let ix = 0; ix < cnt; ix++) { // Save all positions - note currentOrders is in the same array position as the event array
        if (event.value[ix].col != this.curTilePosition[ix].col) {
          changeOrder = currentOrders[ix].item.key;
          console.log(`change order=${changeOrder}, new col=${event.value[ix].col}, previous: ${this.curTilePosition[ix].col}`);
          if (this.curTilePosition[ix].col > event.value[ix].col) { // Move back is not allowed
            oldColumn = this.curTilePosition[ix].col;
            illegalChange = true;
            console.log(`Illegal Change - order: ${changeOrder}, old Col: ${oldColumn}`);
            curTilePosition.push({ key: currentOrders[ix].item.key,order: event.value[ix].order,rowSpan: event.value[ix].rowSpan,col: this.curTilePosition[ix].col });
          } else { // Valid Change - need to update status
            validChange = true;
            curTilePosition.push({ key: currentOrders[ix].item.key,order: event.value[ix].order,rowSpan: event.value[ix].rowSpan,col: event.value[ix].col });
            newColumn = event.value[ix].col;
          }
        } else { // No change - re-add to list
          curTilePosition.push({ key: currentOrders[ix].item.key,order: event.value[ix].order,rowSpan: event.value[ix].rowSpan,col: event.value[ix].col });
        }
      }
      // Note - this assumes only one change per event
      if (changeOrder > 0) {
        if (illegalChange === true) { // Force back to the way it was
          //let curTiles = this.state.TilesInProgress.slice();
          console.log(`----> illegalChange`);
          const curix = currentOrders.findIndex(ent => ent.item.key === changeOrder);
          console.log(`illegal - curix: ${curix}, order: ${changeOrder}, oldColumn: ${oldColumn}`);
          if (curix >= 0) {
            this.fixOrderColOrderID = changeOrder; // OrderID of Illegal Change
            currentOrders[curix].defaultPosition.col = oldColumn; // Reset GridColumn   
            console.log(`- after reset - ID: ${this.fixOrderColOrderID} - current Order: ${JSON.stringify(currentOrders[curix])}`);
            this.fixOrderColFlag = true; // Indicate need to Reposition the Orders
          }
        } else { // Valid Changes
          this.curTilePosition = curTilePosition.slice(); // Save current TilePositions 
          await this.changeCustomOrderStatus(changeOrder,newColumn); // Which column has it moved to
          if (newColumn >= 2) { // Need to refresh Tiles 
            console.log(`refresh fixOrderColOrderID - ${changeOrder}`);
            //this.fixOrderColOrderID = 0; // OrderID of Illegal Change
            // Added 27Jun23 - force refresh to pickup updated Tile    
            this.fixOrderColOrderID = changeOrder; // OrderID of Illegal Change
            this.fixOrderColFlag = true; // Indicate need to Reposition the Orders
          }
        }
      }
      console.log(`repo curTilePosition: ${JSON.stringify(this.curTilePosition)}`);
    }
    catch (ex) {
      console.log(`reposition error: ${ex.message}`);
    }
    finally {
      this.inDrag = false; // After drop - turn off inDrag
      this.timerCount = 51;
      //console.log(`--> SET TIMER COUNT: ${this.timerCount}`);
    }
  }
  async initializeLocation() {
    //this.setState({ verticalPanes: this.vertSplitC });
    if (SessionInfo.KitchenLocationID > 0) {
      await this.getAllStoreLocationDetail();
      await this.setState({ StoreLocationID: SessionInfo.KitchenLocationID });
    }
    if (SessionInfo.KitchenLocationID > 0) {
      console.log("Init - LocationID: " + SessionInfo.KitchenLocationID);
      SessionInfo.headerTitle = this.state.StoreName;
      SessionInfo.itemName = "Item";
      this.state.RightO = false;
      this.setState({ selectedTopTab: 0 });
      this.clearTables();
      if (this.state.Contacts.length <= 1) {
        let CD = await CallOM("GetContacts", 0, SessionInfo.KitchenLocationID, 0); // NameIDList returned
        console.log("Contacts: " + JSON.stringify(CD.d));
        this.setState({ Contacts: CD.d });
      }
      console.log("Get Sublocations - current loc: " + SessionInfo.KitchenLocationID);
      if (this.state.Sublocations.length <= 1) {
        let CD = await CallOM("GetSublocations", 0, SessionInfo.KitchenLocationID, 0); // NameIDList returned
        //console.log("Sublocations: " + JSON.stringify(CD.d));
        this.setState({ Sublocations: CD.d });
      }
      if (this.state.StoreGroups.length <= 1) {
        let CD = await GetDropdownData(544709);
        console.log("StoreGroups Codes: " + JSON.stringify(CD.d));
        this.setState({ StoreGroups: CD.d });
      }
      if (this.state.ProvinceStates.length <= 1) {
        let CD = await GetDependentDropdownData(489030, 124, 163266);
        //console.log("ProvinceState Codes: " + JSON.stringify(CD.d));
        this.setState({ ProvinceStates: CD.d });
      }
      this.closeLeftPane();
      //----------- StoreItem Dictionaries --------------------------------- 
      this.state.StoreAmenitiesList = ["Wifi Available", "Coffee", "Specialty Coffee", "Salads", "Soups", "Hot Meals", "Desserts", "Wine", "Beer"];
      if (this.state.ProductItemCategories.length <= 1) {
        let CD = await GetDropdownData(1104137);
        this.setState({ ProductItemCategories: CD.d });
        this.ItemCategoriesDD = CD.d;
        SetProductItemCategory(CD.d);
      }
      if (this.state.ProductItemGroups.length <= 1) {
        let CD = await GetDropdownData(1104119);
        this.setState({ ProductItemGroups: CD.d });
      }
      if (this.state.ProductItemTypes.length <= 1) {
        let CD = await GetDropdownData(1104125);
        this.setState({ ProductItemTypes: CD.d });
        SetProductType(CD.d);
      }
      if (this.state.ItemStatusSet.length <= 1) {
        let CD = await GetDropdownData(1104159);
        this.setState({ ItemStatusSet: CD.d });
      }
      if (this.state.PromotionTypes.length <= 1) {
        let CD = await GetDropdownData(545179);
        this.setState({ PromotionTypes: CD.d });
      }
      if (this.state.PackagingTypes.length <= 1) {
        let CD = await GetDropdownData(519062);
        this.setState({ PackagingTypes: CD.d });
      }
      if (this.state.PricingTypes.length <= 1) {
        let CD = await GetDropdownData(1104167);
        this.setState({ PricingTypes: CD.d });
        SetPricingType(CD.d);
      }
      if (this.state.RateTypes.length <= 1) {
        let CD = await GetDropdownData(545339);
        this.setState({ RateTypes: CD.d });
      }
      if (this.state.PaymentMethods.length <= 1) {
        let CD = await GetDropdownData(544793);
        this.setState({ PaymentMethods: CD.d });
      }
      //this.setState({ DaysOfWeek: DayOfWeekDD });
      //------ Initialization Code - StoreLocations ------
      if (this.state.StoreLocationsDict.length <= 1) {
        let CD = await GetDropdownData(544596);
        this.setState({ StoreLocationsDict: CD.d });
      }
      if (this.state.StoreGroups.length <= 1) {
        let CD = await GetDropdownData(544709);
        this.setState({ StoreGroups: CD.d });
      }
      if (this.state.StoreItemsDict.length <= 1) {
        let CD = await GetDependentDropdownData(544619, this.state.StoreLocationID, 544598);
        this.setState({ StoreItemsDict: CD.d });
      }
      if (this.state.PromotionTypes.length <= 1) {
        let CD = await GetDropdownData(545179);
        this.setState({ PromotionTypes: CD.d });
      }
    }
    console.log(`Location init - set TAB to Kitchen`);
    console.log(`---------------------- Call refreshTiles Init - Location: ${SessionInfo.KitchenLocationID} -------------------`);
    this.TilesInProgress = [];
    await this.setState({ TilesInProgress: this.TilesInProgress });
    await this.refreshTiles(this.enOrderStatus.OrderInProgress);
    //await this.loadOrders(this.enOrderStatus.OrderInProgress); // Kitchen Orders   
    await this.loadTasks();
    await this.selectTab(this.tabs.KITCHENSTATION);
  }
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------  
  getStoreLocations = async (search) => { // Get the available StoreLocations
    let CD;
    if (!search)
      CD = await GetTableData(545207); // Get StoreInfoView
    else
      CD = await GetTableSearch(545207, search); // Search StoreInfoView - returns different results
    if (CD.x.o >= 9000 && CD.x.o < 9500) {
      try {
        const StoreLocations = CD.d.rows;
        this.setState({ StoreLocations });
        this.setState({ StoreLocationsCount: StoreLocations.length });
      } catch (error) {
        console.log(`getStorelocations Error: ${error.message}`);
        this.props.navigate("/Login");
      }
    }
    else {
      displayError("Unable to retrieve StoreLocations");
      this.setState({ StoreLocations: [] });
    }
  }
  storeLocationRowClick = (event) => {
    //displayMessage("Row Click");
    let last = this.lastSelectedIndex;
    const current = this.state.StoreLocations.findIndex(dataItem => dataItem === event.dataItem);
    this.lastSelectedIndex = last = current;
    this.state.StoreLocations.forEach(item => item.selected = false);
    const select = !event.dataItem.selected;
    for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
      this.state.StoreLocations[i].selected = select;
    }
    let PKID = this.state.StoreLocations[current].StoreLocationID;
    SessionInfo.KitchenLocationID = PKID;
    //displayMessage("Select PKID: " + PKID);
    this.initializeLocation(); // Note - this will show Kitchen Orders
  }
  formatMoney = (amount) => {
    let decimalCount = 2;
    const decimal = ".";
    const thousands = ",";
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substring(0, j) + thousands : '') + i.substring(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  }
  frmt = true;
  percentFormat = this.frmt === true ? (value) => new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value) : (value) => value;
  moneyFormat = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  dateTimeFormat = (value) => new Intl.DateTimeFormat('en-CA', { dateStyle: 'long', timeStyle: 'short' }).format(value)
  dateTimeSFormat = (value) => new Intl.DateTimeFormat('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }).format(Date.parse(value))
  //       
  getCustomOrdersStatus = async (getStatusID) => {
    console.log(`Get CustomOrdersStatus - locationID: ${SessionInfo.KitchenLocationID} StatusID: ${getStatusID}`);
    await this.getCustomOrders("", getStatusID);
  }
  getCustomOrders = async (search,getStatusID) => { // see loadOrders
    if (!search)
      search = '';
    console.log("Get CustomOrders - locationID: " + SessionInfo.KitchenLocationID);
    let CD = await CallOM("GetOrders", getStatusID, SessionInfo.KitchenLocationID, 2, search); // Fetch Pending Orders 
    try {
      this.CustomOrders = CD.d.rows.slice(); //.map(dataItem => Object.assign({ selected: false }, dataItem));
      console.log(`Get CustomOrders(${getStatusID}): ${JSON.stringify(this.CustomOrders)}`);
      if (getStatusID === this.enOrderStatus.OrderPending) {
        this.PendingOrders = this.CustomOrders;
        this.setState({ PendingOrders: this.PendingOrders });
      } else if (getStatusID === this.enOrderStatus.OrderSubmitted) {
        this.SubmittedOrders = this.CustomOrders;
        this.setState({ SubmittedOrders: this.SubmittedOrders });
      } else if (getStatusID === this.enOrderStatus.OrderInProgress) {
        this.InProgressOrders = this.CustomOrders;
        this.setState({ InProgressOrders: this.InProgressOrders });
      } else if (getStatusID === this.enOrderStatus.OrderReady) {
        this.ReadyOrders = this.CustomOrders;
        this.setState({ ReadyOrders: this.ReadyOrders });
      } else if (getStatusID === 102)
        this.setState({ PickupOrders: this.CustomOrders });
      else if (getStatusID === this.enOrderStatus.InDelivery)
        this.setState({ DeliveryOrders: this.CustomOrders });
      else if (getStatusID === 100)
        this.setState({ InPaymentOrders: this.CustomOrders });
      else if (getStatusID >= 8) // Might be >= 8?  this.enOrderStatus.OrderPaid
        this.setState({ CompletedOrders: this.CustomOrders });
    } catch (error) {
      console.log(`Failure in getCustomOrders - Error: ${error.message}`);
      console.log(`CD: ${JSON.stringify(CD)}`);
    }
    //console.log(`Ready: ${JSON.stringify(this.state.ReadyOrders)}`)
  }
  changeCustomOrderStatus = async (customOrderID,newColumn) => {
    let newStatusID = this.enOrderStatus.OrderInProgress;
    if (newColumn === 2)
      newStatusID = this.enOrderStatus.OrderInProgress;
    else if (newColumn === 3)
      newStatusID = this.enOrderStatus.OrderReady;
    let CD = await CallOM("UpdateCustomOrderStatus",newStatusID,customOrderID);
  }
  getAllStoreLocationDetail = async () => {
    console.log("StoreLocationID: " + SessionInfo.KitchenLocationID);
    displayMessage("GREEN");
    //await this.getContact(this.state.ContactID);
    //await this.getLocation(this.state.LocationID);            
    await this.getStoreLocationRecord(SessionInfo.KitchenLocationID);
    this.loadExistingPage = false;
  }
  getStoreLocationRecord = async (Key) => {
    let CD = await CallOM("GetStoreLocation", 0, Key, 0);
    //let CD = await GetTableRow(544596, Key); // Get the current StoreLocation
    if (!CD || !CD.d || CD.o > 9910)
      this.props.navigate("/Login");
    //console.log("after GetStoreLocation: " + JSON.stringify(CD.d));
    this.setState({ StoreLocationID: Key });
    StoreLocationsO.forEach((elem) => {
      if (elem.n in CD.d) {
        //console.log("Set " + elem.n + ": " + CD.d.row[elem.n]); 
        let sobj = {};
        try {
          if (elem.t === 34 || elem.t === 35)
            sobj[elem.n] = new Date(CD.d[elem.n]);
          else
            sobj[elem.n] = CD.d[elem.n];
          //console.log("sobj " + JSON.stringify(sobj));
          this.setState(sobj);
        } catch (error) {
          console.log("Set StoreLocation Field: " + elem.n + " Error: " + error.message);
        }
      }
    });
    //console.log("Amenities: " + this.state.StoreAmenities);
    let AList = [];
    if ((this.state.StoreAmenities & 0x0000000000000800) === 0x0000000000000800)
      AList.push("Beer");
    if ((this.state.StoreAmenities & 0x0000000000000004) === 0x0000000000000004)
      AList.push("Coffee");
    if ((this.state.StoreAmenities & 0x0000000000000200) === 0x0000000000000200)
      AList.push("Desserts");
    if ((this.state.StoreAmenities & 0x0000000000000020) === 0x0000000000000020)
      AList.push("Salads");
    if ((this.state.StoreAmenities & 0x0000000000000040) === 0x0000000000000040)
      AList.push("Soups");
    if ((this.state.StoreAmenities & 0x0000000000000080) === 0x0000000000000080)
      AList.push("Hot Meals");
    if ((this.state.StoreAmenities & 0x0000000000000008) === 0x0000000000000008)
      AList.push("Specialty Coffee");
    if ((this.state.StoreAmenities & 0x0000000000000002) === 0x0000000000000002)
      AList.push("Wifi Available");
    if ((this.state.StoreAmenities & 0x0000000000000400) === 0x0000000000000400)
      AList.push("Wine");
    console.log("Amenities AList: " + JSON.stringify(AList));
    this.setState({ StoreAmenitiesVals: AList });
    //this.state.StoreAmenitiesList = ["Wifi Available", "Coffee", "Specialty Coffee", "Salads", "Soups", "Hot Meals", "Desserts", "Wine", "Beer"];
    this.setItemStateChanged(false);
  }
  //-------------------- End of Page Edit -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  //------ Help Information -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  showHelp = async (key) => {
    if (this.state.showHelpListPopup == true) { // Close Help
      this.setState({ showHelpListPopup: false });
      this.setState({ showHelpDetail: false });
    } else {
      if (!key)
        key = '';
      this.setState({ showHelpDetail: false });
      let HelpPages = await getHelpTopics(key);
      //console.log("caller HelpPages: " + JSON.stringify(HelpPages));
      this.setState({ HelpPages });
      this.setState({ showHelpListPopup: true });
    }
  }
  closeHelpList = () => {
    this.setState({ showHelpListPopup: false });
  }
  onHelpItemClick = async (item) => {
    let helpDetail = await getHelpDetail(item.HelpPageID);
    this.setState({ helpDetail });
    this.setState({ showHelpDetail: true });
  }
  closeHelpTime = async () => {
    this.setState({ showHelpDetail: false });
  }
  onObjectHelp = async (objectID) => {
    let helpDetail = await getHelpDetail(objectID,2);
    this.setState({ helpDetail });
    this.setState({ showHelpDetail: true });
  }
  closeHelpTime = async () => {
    this.setState({ showHelpDetail: false });
  }
  // Help List Layout
  HelpPageHeader = () => {
    return (
      <ListViewHeader className='listHelpHeader' onClick={(e) => this.closeHelpList()} >
        <div className='listHeaderLeft' onClick={(e) => this.closeHelpList()}>
          <span className="listHelpTitle">{SessionInfo.HelpTitle}</span>
        </div>
        <div className='listHeaderRight' onClick={(e) => this.closeHelpList()}>
          <Button id="cancelButton" icon="cancel" look="outline" className="medButton" onClick={this.closeHelpList} >EXIT HELP</Button>
        </div>
      </ListViewHeader>
    );
  }
  HelpPageFormat = props => {
    let item = props.dataItem;
    return (
      <div>
        <div className="listHelpRow" onClick={(e) => this.onHelpItemClick(item)}>
          <div className="listColA">
            <span className="listHelpItemTitle" >{item.HelpTitle}&nbsp;&nbsp;&nbsp;</span>
            <div dangerouslySetInnerHTML={{ __html: item.HelpContent }}></div>
          </div>
        </div>
      </div>
    );
  }
  HelpPageFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listHelpFooter' onClick={(e) => this.closeHelpList()} >
        <div className='listHeaderRight' onClick={(e) => this.closeHelpList()}>
          <Button id="cancelButton" icon="cancel" look="outline" className="medButton" onClick={this.closeHelpList} >EXIT HELP</Button>
        </div>
      </ListViewFooter>
    );
  }
  ShowFieldHelp = async (key) => {
    console.log(`Field Help - Key: ${key}`);
    this.onObjectHelp(key);
    //this.showHelp(key);
    //console.log(`Field Help: ${JSON.stringify(item)}`);
  }
  //------ End of Help -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  //------------------------- Select Invite----------------------------------------------------------------------
  selectionHoursOfOpChange = (event) => {
    event.dataItem.selected = !event.dataItem.selected;
    this.forceUpdate();
  }
  //------------------------- Select Receipts Row ---------------------------------------------------
  orderRowClick = async (event) => {
    console.log(`orderRowClick - currentTab: ${this.currentTab}`);
    let current = -1;
    let orderLine = undefined;
    switch (this.currentTab) {
      case this.tabs.PENDINGORDERS:
        current = this.state.PendingOrders.findIndex(dataItem => dataItem === event.dataItem);
        if (current >= 0) orderLine = this.state.PendingOrders[current];
        break;
      case this.tabs.CURRENT:
        current = this.state.InProgressOrders.findIndex(dataItem => dataItem === event.dataItem);
        if (current >= 0) orderLine = this.state.InProgressOrders[current];
        break;
      case this.tabs.READY:
        current = this.state.ReadyOrders.findIndex(dataItem => dataItem === event.dataItem);
        if (current >= 0) orderLine = this.state.ReadyOrders[current];
        break;
      case this.tabs.READYFORPICKUP:
        current = this.state.PickupOrders.findIndex(dataItem => dataItem === event.dataItem);
        if (current >= 0) orderLine = this.state.PickupOrders[current];
        break;
      case this.tabs.INDELIVERY:
        current = this.state.DeliveryOrders.findIndex(dataItem => dataItem === event.dataItem);
        if (current >= 0) orderLine = this.state.DeliveryOrders[current];
        break;
      case this.tabs.INPAYMENT:
        current = this.state.InPaymentOrders.findIndex(dataItem => dataItem === event.dataItem);
        if (current >= 0) orderLine = this.state.InPaymentOrders[current];
        break;
      case this.tabs.COMPLETEDORDERS:
        current = this.state.CompletedOrders.findIndex(dataItem => dataItem === event.dataItem);
        if (current >= 0) orderLine = this.state.CompletedOrders[current];
        break;
    }
    console.log(`CustomOrder Click - current: ${current}`);
    if (current >= 0) {
      SessionInfo.CustomOrderID = orderLine.CustomOrderID;
      let CD = await GetTableRowTrans(545072, SessionInfo.CustomOrderID);
      //console.log("after Get: " + JSON.stringify(CD.d));
      CustomOrdersO.forEach((elem) => {
        if (elem.n in CD.d.row) {
          //console.log("Set " + elem.n + ": " + CD.d.row[elem.n]); 
          let sobj = {};
          try {
            if (elem.t === 34 || elem.t === 35)
              sobj[elem.n] = new Date(CD.d.row[elem.n]);
            else
              sobj[elem.n] = CD.d.row[elem.n];
            //console.log("sobj " + JSON.stringify(sobj));
            this.setState(sobj);
          } catch (error) {
            console.log("Set CustomOrder Field: " + elem.n + " Error: " + error.message);
          }
        }
      });
      this.setItemStateChanged(false);
      await this.getCustomOrderItems();
    }
  }
  getCustomOrderItems = async (search) => {
    if (!search)
      search = '';
    console.log("Get CustomOrderItems - CustomOrderID=" + SessionInfo.CustomOrderID); // Note - CustomOrderID needs to be set
    let CD = await GetTableSearch(545113, search + "*CustomOrderID=" + SessionInfo.CustomOrderID, "StoreItemID,Quantity,OptionCount,TotalPrice"); // Note - CustomOrderID needs to be set
    //console.log("CustomOrderItems: " + JSON.stringify(CD.d));
    try {
      const CustomOrderItems = CD.d.rows.map(dataItem => Object.assign({ selected: false }, dataItem));
      this.setState({ CustomOrderItems });
      this.setState({ customOrderItemsCount: CustomOrderItems.length });
    } catch (error) {
      console.log("Failure in getCustomOrderItems - Error: " + error.message);
    }
  }
  customOrdersPageChange = (event) => {
    this.setState({ customOrdersSkip: event.page.skip, customOrdersTake: event.page.take });
  }
  //--------------------------------------------------------------
  //promoRowClick = async (event) => { // GetPromotions
  //  const current = this.state.Promotions.findIndex(dataItem => dataItem === event.dataItem);
  //  if (current >= 0) {
  //    this.state.StorePromotionID = this.state.Promotions[current].StorePromotionID;
  //    let CD = await GetTableRowRaw(544701, this.state.StorePromotionID);
  //    console.log("after Get: " + JSON.stringify(CD.d));
  //    StorePromotionsO.forEach((elem) => {
  //      if (elem.n in CD.d.row) {
  //        //console.log("Set " + elem.n + ": " + CD.d.row[elem.n]); 
  //        let sobj = {};
  //        try {
  //          if (elem.t === 34 || elem.t === 35)
  //            sobj[elem.n] = new Date(CD.d.row[elem.n]);
  //          else
  //            sobj[elem.n] = CD.d.row[elem.n];
  //          //console.log("sobj " + JSON.stringify(sobj));
  //          this.setState(sobj);
  //        } catch (error) {
  //          console.log("Set Promotion Field: " + elem.n + " Error: " + error.message);
  //        }
  //      }
  //    });
  //    await this.GetPromotionImage(this.state.ImageID);
  //    this.setItemStateChanged(false);
  //    this.setState({ selectedTopTab: 6 });  // Promotions
  //  }
  //}
  promoPageChange = (event) => {
    this.setState({ promoSkip: event.page.skip, promoTake: event.page.take });
  }

  //------------------------- Image Management ------------------------------
  onSelectImageFile = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    //console.log("StoreItemID: " + this.state.StoreItemID);
    //if (this.state.StoreItemID === 0 && this.InsertRecordType != 1)
    if (this.state.StoreItemID === 0)
      displayWarning("Product Item must be Selected or Added First");
    else {
      this.file = event.target.files[0];
      //console.log("File: " + JSON.stringify(file));
      //this.setState({ ContractFileName: file.name });
      let reader = new window.FileReader();
      this.fileReady = false;
      try {
        reader.readAsArrayBuffer(this.file);
        reader.onloadend = async () => {
          await this.convertToBuffer(reader);
          this.fileReady = true;
          displayMessage("Image: " + this.file.name + " Loaded");
          this.DocumentLoaded = true;
          this.DocumentSaved = false;
        }
        this.fileCheck();
        event.target.value = null;
      }
      catch (error) {
        console.log("FileReader Error: " + error);
        displayError("Error on File Read");
        return;
      }
    }
  }
  fileCheck = async () => {
    if (this.fileReady === true) {
      let ImageType = GetFileExtension(this.file.name);
      //console.log("ImageType: " + ImageType);
      ImageType = ImageType.toLowerCase();
      this.setState({ ImageType });
      let ix = SessionInfo.DocumentTypes.findIndex(c => c.ddName === ImageType);
      if (ix >= 0) {
        this.setState({ DocumentTypeID: SessionInfo.DocumentTypes[ix].ddID });
        let iVal = await this.saveImageToServer(this.StorePromotionsOID, this.state.StorePromotionID); // Note StorePromotionsTable
        displayMessage(`Image saved for '${this.state.ItemName}'`);
        setTimeout(this.retrieveImage, 1000, iVal);
      }
      else
        displayWarning("Unknown file type: " + ImageType);
      return;
    }
    setTimeout(this.fileCheck, 200);
  }
  retrieveImage = async (iVal) => {
    console.log("Retrieve Image: " + iVal);
    await this.GetPromotionImage(iVal);
  }
  convertToBuffer = async (reader) => { // File is converted to a buffer to prepare for uploading to OM
    const UploadFile = await Buffer.from(reader.result);
    //set this buffer -using es6 syntax
    this.setState({ UploadFile });
    //console.log("converToBuffer - Image uploadfile Length: " + UploadFile.length);
    // Display the image
    let image = new Blob([UploadFile], { type: 'image/jpeg' });
    let imageURL = URL.createObjectURL(image);
    this.setState({ ProductItemPhotoURL: imageURL });
  };
  saveImageToServer = async (tableObjID, itemID) => {
    //console.log('saveImageToServer: ');
    if (this.isSavingDocument) {
      displayMessage("Document Save in Progress");
      return;
    }
    else if (!this.state.UploadFile)
      displayError('A file must be selected');
    else {
      this.isSavingDocument = true;
      //displayMessage('Saving Image for ' + this.state.ProductItemCategory);
      //console.log("Save Image " + JSON.stringify(this.state.UploadFile));
      let CD = await CallOM("SaveProductImage", tableObjID, itemID, 20, this.state.UploadFile, this.state.ImageType); // 17
      console.log("Saved Image " + this.state.UploadFile.length);
      this.isSavingDocument = false;
      let ival = CD.d;
      return ival;
    }
  }
  GetPromotionImage = async (imageID) => {
    const imageURL = await getImageFileFromServer(imageID);
    this.setState({ PromotionPhotoURL: imageURL });
  }
  //--------------------------------------------------------------
  onSaveStoreItem = async () => {
    let copyState = Object.assign({}, this.state);
    let type = 0;
    for (var prop in copyState) {
      if (prop === "string") {
        type = 1;
        copyState[prop] = undefined;
      }
      else if (prop === "selectedTopTab")
        type = 2;
      else if (type === 0) {
      }
      if (type === 2) {
        copyState[prop] = undefined;
      }
    }
    //console.log("WorkflowID: " + JSON.stringify(copyState));
    await UpdateRow(544619, 0, undefined, copyState, copyState.StoreItemID, "StoreItemID"); // Save to OM 
    //await this.getRecords();
    this.setItemStateChanged(false);
  }
  onAddStoreItem = async () => {
    this.setState({ StoreItemID: 0 });
    this.setState({ ProductItemCategoryID: 0 });
    this.setState({ ProductItemGroupID: 0 });
    this.setState({ ProductItemTypeID: 0 });
    this.setState({ ShelfLifeDays: 0 });
    this.setState({ ItemPrice: 0 });
    this.setState({ ItemStatusID: 0 });
    this.setState({ PackagingTypeID: 0 });
    this.setState({ PricingTypeID: 0 });
    this.setState({ RateTypeID: 0 });

    this.setState({ ItemName: 'NewItem' });
    this.setState({ ItemDescription: '' });
    this.setState({ UPCNumber: '' });
    this.setState({ BarcodeNumber: '' });
    displayMessage("Ready for New Store Item");
  }
  //------------------------- Edit StoreItem Grid ------------------------------------------------------------------  
  StoreItemCommandCell;
  enterInsertSI() {
    const dataItem = { inEdit: true };
    const allRecords = this.state.StoreItems.slice();
    allRecords.unshift(dataItem); // Add to the beginning
    this.updateStoreItems(allRecords, dataItem);
    this.setState({ StoreItems: allRecords });
  }
  enterEditSI(dataItem) {
    this.updateStoreItems(this.state.StoreItems, dataItem).inEdit = true;
    this.setState({ StoreItems: this.state.StoreItems.slice() });
  }
  saveSI(dataItem) {
    dataItem.inEdit = undefined;
    if (dataItem.StoreItemID === undefined)
      dataItem.StoreItemID = 0;
    console.log("Save");
    dataItem.StoreItemID = this.updateStoreItems(this.state.StoreItems, dataItem).StoreItemID;  // Save to OM
    this.setState({ StoreItems: this.state.StoreItems.slice() });
    //console.log("Update Row - locationID: " + dataItem.StoreLocationID);
    UpdateRow(545207, 0, this.state.StoreItems, dataItem, dataItem.StoreLocationID, "StoreLocationID");  // Update StoreInfoView
  }
  cancelSI(dataItem) {
    if (dataItem.StoreItemID) {
      let originalItem = this.state.StoreItems.find(p => p.StoreItemID === dataItem.StoreItemID)
      if (originalItem.inEdit) originalItem.inEdit = false;
      this.updateStoreItems(this.state.StoreItems, originalItem);
    } else {
      this.updateStoreItems(this.state.StoreItems, dataItem, !dataItem.StoreItemID); // remove false
    }
    this.setState({ StoreItems: this.state.StoreItems.slice() });
  }
  removeSI(dataItem) {
    dataItem.inEdit = undefined;
    let key = dataItem.StoreItemID;
    console.log("remove: " + key);
    //console.log("dateitem: " + JSON.stringify(dataItem));
    //console.log("Before StoreItems: " + JSON.stringify(this.state.StoreItems.slice()));
    this.updateStoreItems(this.state.StoreItems, dataItem, true);
    //console.log("After StoreItems: " + JSON.stringify(this.state.StoreItems.slice()));
    DeleteRowTry(this.StoreItemsOID, key); // Delete in the StoreItems Table in OM  
    this.setState({ StoreItems: this.state.StoreItems.slice() });
  }
  itemChangeSI(event) {
    const value = event.value;
    const name = event.field;
    if (!name) {
      return;
    }
    const updatedData = this.state.StoreItems.slice();
    const item = this.updateStoreItems(updatedData, event.dataItem);
    //console.log("itemChange - name: " + name + " value: " + JSON.stringify(value));
    if (!value.ddID)
      item[name] = value;
    else
      item[name] = value.ddID;
    this.setState({ StoreItems: updatedData });
  }
  updateStoreItems(data, item, remove) {  // data - is the entire data set (JSON), item - is the current line 
    let updated;
    //eslint-disable-next-line                   
    let index = data.findIndex(p => p === item || item.StoreItemID && p.StoreItemID === item.StoreItemID); // Note - for new line will find 0
    if (index >= 0) {
      updated = Object.assign({}, item);
      data[index] = updated;
    }
    if (remove) {
      data = data.splice(index, 1);
    }
    return data[index];
  }
  //------------------------- End Edit StoreItem Grid ------------------------------------------------------------------

  //------------------------ Promotions ---------------------------------------------------------------
  onCreatePromotion = async () => {
    await this.saveRecord();
  }
  //------------------------- Edit HoursOfOperation Grid ------------------------------------------------------------------
  HOOItemCommandCell;
  enterInsertHOO() {
    console.log("Insert HoursOfOperation");
    const dataItem = { inEdit: true };
    const allRecords = this.state.HoursOfOperation.slice();
    allRecords.unshift(dataItem); // Add to the beginning 
    //console.log("Call Update HoursOfOperation");
    this.updateHOOItems(allRecords, dataItem);
    //console.log("After Update HoursOfOperation");
    this.setState({ HoursOfOperation: allRecords });
    console.log("end HoursOfOperation");
  }
  enterEditHOO(dataItem) {
    this.updateHOOItems(this.state.HoursOfOperation, dataItem).inEdit = true;
    this.setState({ HoursOfOperation: this.state.HoursOfOperation.slice() });
  }
  saveHOO(dataItem) {
    dataItem.inEdit = undefined;
    if (dataItem.HoursOfOpID === undefined)
      dataItem.HoursOfOpID = 0;
    //console.log("Save");
    dataItem.HoursOfOpID = this.updateHOOItems(this.state.HoursOfOperation, dataItem).HoursOfOpID;  // Save to OM
    this.setState({ HoursOfOperation: this.state.HoursOfOperation.slice() });
    this.updateHOOItems(this.state.HoursOfOperation, dataItem);
    //console.log("save dataItem: " + JSON.stringify(dataItem));
    let saveItem = JSON.parse(JSON.stringify(dataItem)); // Copy Object
    let offset = new Date().getTimezoneOffset(); // UTC Offset
    console.log("starttime: " + dataItem.StartTime + " offset: " + offset);
    if (offset !== 0) {
      let strdate = moment(dataItem.StartTime).toISOString(); // convert to UTC
      let strt = new Date(strdate);
      //console.log("save - starttime: " + strt + " offset: " + offset);
      saveItem.StartTime = new Date(strt.setTime(strt.getTime() + -offset * 60000));
      //console.log("save after - starttime: " + JSON.stringify(saveItem.StartTime) + " offset: " + offset);
      //console.log("after after - starttime: " + saveItem.StartTime + " offset: " + offset);
    }
    //console.log("endtime: " + saveItem.EndTime.toString() + " offset: " + offset);
    if (offset !== 0) {
      try {
        let end = new Date(dataItem.EndTime.toISOString()); // Convert to UTC and back to Date Object
        saveItem.EndTime = new Date(end.setTime(end.getTime() + -offset * 60000));
      }
      catch (Ex) {
        console.log("saveHOO - EndTime: " + saveItem.EndTime + " Msg: " + Ex);
      }
    }
    //console.log("Update Row : " + JSON.stringify(saveItem));
    CallOM("UpdateHoursOfOperation", 544608, saveItem.HoursOfOpID, 13, saveItem);
    console.log("after dataItem: " + JSON.stringify(dataItem));
    //UpdateRow(544608, 0, this.state.HoursOfOperation, dataItem, dataItem.HoursOfOpID, "HoursOfOpID");  // Update StoreInfoView
  }
  cancelHOO(dataItem) {
    if (dataItem.HoursOfOpID) {
      let originalItem = this.state.HoursOfOperation.find(p => p.HoursOfOpID === dataItem.HoursOfOpID)
      if (originalItem.inEdit) originalItem.inEdit = false;
      this.updateHOOItems(this.state.HoursOfOperation, originalItem);
    } else {
      this.updateHOOItems(this.state.HoursOfOperation, dataItem, !dataItem.HoursOfOpID); // remove false
    }
    this.setState({ HoursOfOperation: this.state.HoursOfOperation.slice() });
  }
  removeHOO(dataItem) {
    dataItem.inEdit = undefined;
    let key = dataItem.HoursOfOpID;
    console.log("remove: " + key);
    this.updateHOOItems(this.state.HoursOfOperation, dataItem, true);
    this.state.saveHoursOfOperations = this.state.HoursOfOperation;
    DeleteRowTry(544608, key); // Delete in the HoursOfOperation Table in OM
    this.setState({ HoursOfOperation: this.state.HoursOfOperation.slice() });
  }
  itemChangeHOO(event) {
    const value = event.value;
    const name = event.field;
    if (!name)
      return;
    const updatedData = this.state.HoursOfOperation.slice();
    const item = this.updateHOOItems(updatedData, event.dataItem);
    console.log("itemChange - name: " + name + " value: " + JSON.stringify(value));
    if (!value.ddID)
      item[name] = value;
    else
      item[name] = value.ddID;
    this.setState({ HoursOfOperation: updatedData });
  }
  updateHOOItems(data, item, remove) {  // data - is the entire data set (JSON), item - is the current line 
    let updated;
    //eslint-disable-next-line                   
    let index = data.findIndex(p => p === item || item.HoursOfOpID && p.HoursOfOpID === item.HoursOfOpID); // Note - for new line will find 0
    if (index >= 0) {
      updated = Object.assign({}, item);
      data[index] = updated;
    }
    if (remove) {
      data = data.splice(index, 1);
    }
    return data[index];
  }
  //------------------------- End Edit HoursOfOperation Grid ------------------------------------------------------------------    
  //--------------------- List Element Formats -----------------------------------------------
  OrderHeader = () => {
    return (
      <ListViewHeader style={{ color: 'rgb(160, 160, 160)', fontSize: 14 }} className='pl-4 pb-2 pt-2'>
        Orders {this.state.OrderState}
      </ListViewHeader>
    );
  }
  OrderFormat = props => {
    const minDate = new Date(2019, 9, 9);
    let item = props.dataItem;
    let imageVal = undefined;
    if (item["Image"]) {
      let value = item["Image"];
      //console.log("ImageCell value: " + value);
      const byteCharacters = window.atob(value);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let image = new Blob([byteArray], { type: 'image/jpeg' });
      //console.log("image: " + JSON.stringify(image));
      imageVal = URL.createObjectURL(image);
    }
    return (
      <div className="listRow" onClick={(e) => this.ViewDetail(item)}>
        <div className="listCol1">
          <span style={{ fontSize: 16, color: "black" }} >Order Type: </span>
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{item.CustomOrderType}</span><br />
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{item.CustomerID}</span><br />
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{item.PhoneNumber}</span><br />
        </div>
        <div className="listCol2">
          <span style={{ fontSize: 16, color: "black" }} >Total: </span>
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{this.moneyFormat(item.TotalPrice)}</span> <br />
          <span style={{ fontSize: 16, color: "black" }} >Items: </span>
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{item.ItemCount}</span>
        </div>
        <div className="listCol3">
          <span style={{ fontSize: 16, color: "black" }} >Ordered: </span>
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{!item.OrderCreationDate || Date.parse(item.OrderCreationDate) < minDate ? "" : this.dateTimeSFormat(item.OrderCreationDate)}</span>  <br />
          <span style={{ fontSize: 16, color: "black" }} >Requested: </span>
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{!item.OrderCreationDate || Date.parse(item.RequestDateTime) < minDate ? "ASAP" : this.dateTimeSFormat(item.RequestDateTime)}</span> <br />
          <span style={{ fontSize: 16, color: "black" }} >Scheduled: </span>
          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{!item.ScheduledPrepDateTime || Date.parse(item.ScheduledPrepDateTime) < minDate ? "" : this.dateTimeSFormat(item.ScheduledPrepDateTime)}</span>
        </div>
        <div className="listCol4">
          <img src={require("./images/delete.svg")} alt="" id="GridRefresh" title="Accept the current entry" className="functionImage" onClick={(e) => this.ClickPending(item)} /><br /> {/*onClick={this.ClickPending(item)} */}
          <Button imageUrl={require("./images/delete.svg")} onClick={(e) => this.ClickPending(item)}>View Details</Button> {/* */}
        </div>
      </div>
    );
  }
  OrderFooter = () => {
    return (
      <ListViewFooter className='listFooter'>
        <div className='footerLeft'>
          <span>SubTotal </span>
          <span>{this.moneyFormat(this.state.SubTotalPrice)}</span>
          <br />
          <span style={{ left: '180px', }}>Tax </span>
          <span>{this.moneyFormat(this.state.TotalTaxAmount)}</span>
        </div>
        <div className='footerRight'>
          <span>TOTAL </span>
          <span>{this.moneyFormat(this.state.TotalPrice)}</span>
          <br />
          <Button id="checkoutButton" icon="restore" style={{ cursor: 'pointer', fontSize: 'large', color: 'black', fontWeight: 'bold', borderRadius: '10px', left: '80px', }} onClick={this.onCheckout} >Checkout</Button>
        </div>
      </ListViewFooter>
    );
  }
  //---------------------------------------------------------------
  OrderItemHeader = () => {
    return (
      <ListViewHeader style={{ color: 'black', fontSize: 18 }} className='pl-4 pb-2 pt-2'>
        Order Details For: {this.state.CustomerName}
      </ListViewHeader>
    );
  }
  OrderItemFormat = props => {
    let item = props.dataItem;
    let imageVal = undefined;
    let optionsList = "<span style='color:#ff1a75'> OPTIONS </span><br/>";
    console.log("optionList value: " + optionsList);
    if (item["Image"]) {
      let value = item["Image"];
      //console.log("ImageCell value: " + value);
      const byteCharacters = window.atob(value);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let image = new Blob([byteArray], { type: 'image/jpeg' });
      //console.log("image: " + JSON.stringify(image));
      imageVal = URL.createObjectURL(image);
    }
    return (
      <div className="listRow">
        <div className="topItems">
          <div className="listCol1">
            <span style={{ fontSize: 16, color: "black" }} >Item: </span>
            <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{item.StoreItemID}</span><br />
            <span style={{ fontSize: 16, color: "black" }} >{item.ItemDescription}</span>
          </div>
          <div className="listCol2">
            <span style={{ fontSize: 16, color: "black" }} >Price: </span>
            <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{this.moneyFormat(item.Price)}</span> <br />
            <span style={{ fontSize: 16, color: "black" }} >Options: </span>
            <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{this.moneyFormat(item.OptionsPrice)}</span>
          </div>
          {/*<div className="listCol4">
            <Avatar shape='rounded' type='image' style={{ height: '50px', width: '50px', }}>
            <img src={imageVal} style={{ height: '50px', width: '50px', }} />
          </Avatar> 
          </div>  */}
          <div className="listCol3">
            <img src={require("./images/delete.svg")} alt="" id="GridRefresh" title="Delete the current entry" className="functionImage" onClick={(e) => window.confirm(`Delete ${item.ItemName.trimRight()}?`) && this.onDeleteItem(item)} /> {/* */}
          </div>
        </div>
        {this.hasOptions == true ?
          <div className="bottomItems">
            <div id="itemOptions" dangerouslySetInnerHTML={{ __html: optionsList }} ref={(div) => { this.anchor = div; }}></div>
          </div> : null}
      </div>
    );
  }
  OrderItemFooter = () => {
    return (
      <ListViewFooter className='listFooter'>
        <div className='footerLeft'>
          <span>SubTotal </span>
          <span>{this.moneyFormat(this.state.SubTotalPrice)}</span>
          <br />
          <span style={{ left: '180px', }}>Tax </span>
          <span>{this.moneyFormat(this.state.TotalTaxAmount)}</span>
        </div>
        <div className='footerRight'>
          <span>TOTAL </span>
          <span>{this.moneyFormat(this.state.TotalPrice)}</span>
          <br />
        </div>
      </ListViewFooter>
    );
  }
  //------------------- ListView Events ----------------------------------------------------------
  ClickPending = (item) => {
    console.log("ClickPending: " + JSON.stringify(item));
    var CustomerID = item.CustomerID;
    //this.setState({ CustomerName: item.CustomOrderID }); 
    var CustomerName = item.CustomerID;
    console.log("CustomerName: " + CustomerName);
    this.setState({ CustomerName: item.CustomerID });
    const curTime = new Date();
    this.state.ScheduledPrepDateTime = curTime.setMinutes(curTime.getMinutes() + 30);
    this.setState({ showPopup: !this.state.showPopup });
  }
  ClickMinus = () => {
    console.log("ScheduledPrepDateTime: " + this.state.ScheduledPrepDateTime);
    //const curTime = Date.parse(this.state.ScheduledPrepDateTime);
    const curTime = new Date(this.state.ScheduledPrepDateTime);
    this.setState({
      ScheduledPrepDateTime: curTime.setMinutes(curTime.getMinutes() - 1)
    });
  }
  ClickPlus = () => {
    console.log("ScheduledPrepDateTime: " + this.state.ScheduledPrepDateTime);
    //const curTime = Date.parse(this.state.ScheduledPrepDateTime);
    const curTime = new Date(this.state.ScheduledPrepDateTime);
    this.setState({
      ScheduledPrepDateTime: curTime.setMinutes(curTime.getMinutes() + 1)
    });
  }
  ViewDetail = (item) => {
    this.state.CustomOrderID = item.CustomOrderID;
    this.getCustomOrderItemsStatus(2);
    this.setState({ CustomerName: item.CustomerID });
    var TaxAmt = item.TotalTaxAmount + item.TotalTax2Amount + item.TotalTax3Amount;
    this.setState({ TotalTaxAmount: TaxAmt });
    this.setState({ TotalPrice: item.TotalPrice });
    this.setState({ SubTotalPrice: item.TotalPrice - TaxAmt });
  }
  //---------------------
  /**
 * Adds time to a date. Modelled after MySQL DATE_ADD function.
 * Example: dateAdd(new Date(), 'minute', 30)  //returns 30 minutes from now.
 * https://stackoverflow.com/a/1214753/18511
 * 
 * @param date  Date to start with
 * @param interval  One of: year, quarter, month, week, day, hour, minute, second
 * @param units  Number of units of the given interval to add.
 */
  dateAdd(date, interval, units) {
    if (!(date instanceof Date))
      return undefined;
    var ret = new Date(date); //don't change original date
    var checkRollover = function () { if (ret.getDate() !== date.getDate()) ret.setDate(0); };
    switch (String(interval).toLowerCase()) {
      case 'year': ret.setFullYear(ret.getFullYear() + units); checkRollover(); break;
      case 'quarter': ret.setMonth(ret.getMonth() + 3 * units); checkRollover(); break;
      case 'month': ret.setMonth(ret.getMonth() + units); checkRollover(); break;
      case 'week': ret.setDate(ret.getDate() + 7 * units); break;
      case 'day': ret.setDate(ret.getDate() + units); break;
      case 'hour': ret.setTime(ret.getTime() + units * 3600000); break;
      case 'minute': ret.setTime(ret.getTime() + units * 60000); break;
      case 'second': ret.setTime(ret.getTime() + units * 1000); break;
      default: ret = undefined; break;
    }
    return ret;
  }
  //---- Top Tab -----------------------------------
  handleTopTabSelect = async (e) => { // Tab Selection
    await this.selectTab(e.selected);
  }
  selectTab = async (tabNumber) => {
    console.log(`selectTab - TabN=${tabNumber} KitchenLocationID=${SessionInfo.KitchenLocationID}`);
    if (SessionInfo.clearSearch)
      SessionInfo.clearSearch();
    this.clearRecord();
    if (tabNumber === this.tabs.SCHEDULER) {
      //displayWarning("Scheduler Selected");
      this.setState({ selectedTopTab: tabNumber });
      //await this.loadEvents(2); // Open/Pending
      SessionInfo.setGridRefresh = 1; // Grid Refresh in orderID  
      SessionInfo.setExcelExport = 1;
      SessionInfo.setShowSave = 2; // Show Save in orderID 
      SessionInfo.setShowNew = 2;
      SessionInfo.currExcelExportFunc = this.exportCustomOrdersExcel;
      SessionInfo.searchTitle = "Search Events";
      this.setState({ verticalPanes: this.vertSplitC });
      this.closeLeftPane();           
      this.closeRightPane();
      this.currentTab = tabNumber;
    }
    else if (SessionInfo.KitchenLocationID > 0) {
      await this.setState({ selectedTopTab: tabNumber });
      SessionInfo.setGridRefresh = 2; // Hide Grid Refresh in orderID 
      SessionInfo.setExcelExport = 2;
      SessionInfo.setGridAdd = 2;
      this.currentTab = tabNumber;
      // Initialize according to the tab
      if (tabNumber === this.tabs.KITCHENSTATION) {
        console.log(`--> Kitchen Orders Tab`);
        this.setState({ verticalPanes: this.vertSplitC });
        this.closeLeftPane();
        this.closeRightPane();
        SessionInfo.searchTitle = "Search Current Orders";
        await this.refreshTiles(this.enOrderStatus.OrderInProgress);
        // Note: loadOrders called on screen init         
        //await this.buildTiles(this.enOrderStatus.OrderSubmitted); 
        //await this.buildTiles(this.enOrderStatus.OrderInProgress);
        //await this.buildTiles(this.enOrderStatus.OrderReady);
      //  console.log('----------------- Submitted ----------------------')
      //  console.log(`Submitted: ${JSON.stringify(this.state.TilesSubmitted)}`);
      //  console.log('----------------- InProgress ----------------------')
      //  console.log(`InProgress: ${JSON.stringify(this.state.TilesInProgress)}`);
      //  console.log('----------------- Ready ----------------------')
      //  console.log(`Ready: ${JSON.stringify(this.state.TilesReady)}`);
      //  let array = this.TilesInProgress.concat(this.TilesSubmitted,this.TilesReady); // Combine Submitted and Ready with InProgress - 3 columns
      //  console.log(`combined: ${JSON.stringify(array)}`);
      //  await this.setState({ TilesInProgress : array });
      }
      else if (tabNumber === this.tabs.PENDINGORDERS) {
        this.setState({ verticalPanes: this.vertSplitC });
        this.closeLeftPane();
        this.closeRightPane();
        SessionInfo.searchTitle = "Search Pending Orders";
        await this.getCustomOrdersStatus(2); // Pending + OrderOpen
      }
      else if (tabNumber === this.tabs.KITCHENORDERS) { // In Progress
        this.setState({ verticalPanes: this.vertSplitC });
        this.closeLeftPane();
        this.closeRightPane();
        SessionInfo.searchTitle = "Search In Progress Orders";
        await this.getCustomOrdersStatus(5); // Pending + OrderOpen
      }
      else if (tabNumber === this.tabs.READY) {
        await this.setState({ RightO: false });
        this.closeLeftPane();
        SessionInfo.searchTitle = "Search Ready Orders";
        this.openRightPaneWide(false);
        //await this.getCustomOrdersStatus(this.enOrderStatus.Ready);
        await this.getCustomOrdersStatus(6); // Ready
      }
      else if (tabNumber === this.tabs.COMPLETEDORDERS) {
        SessionInfo.searchTitle = "Search Completed Orders";
        this.closeLeftPane();
        this.openRightPaneWide(false);
        SessionInfo.setGridRefresh = 1; // Grid Refresh in orderID  
        SessionInfo.setExcelExport = 1;
        SessionInfo.currExcelExportFunc = this.exportStoreItemsExcel;
        await this.getCustomOrdersStatus(8); // Delivered + PickedUP,OrderPaid,OrderUnderPaid
      }
      else if (tabNumber === this.tabs.MANAGEMENT) {
        this.closeLeftPane();
        this.closeRightPane();
        SessionInfo.setShowSave = 1; // Show Save in orderID 
        SessionInfo.setShowNew = 1;
        SessionInfo.currExcelExportFunc = this.exportPromotionsExcel;
      }
    }
    else {
      displayWarning("Store Location must be Selected");
      this.setState({ selectedTopTab: 0 });
    }
  }
  //---- Bottom Tab -----------------------------------
  handleBottomTabSelect = async (e) => {
    this.setState({ selectedBottomTab: e.selected });
  }
  _exportStoreItems;
  exportStoreItemsExcel = () => {
    this._exportStoreItems.save();
  }
  _exportCustomOrders;
  exportCustomOrdersExcel = () => {
    this._exportCustomOrders.save();
  }
  _exportPromotions;
  exportPromotionsExcel = () => {
    this._exportPromotions.save();
  }
  handleChange = (event) => {
    this.setState({
      value: event.target.value
    });
  }
  async blurMaskFldVal(event,mask) {
    //console.log(`blur Mask: ${this.state[event.target.name]}`);
    this.setState({ [event.target.name]: UnmaskString(this.state[event.target.name],mask) });
    //console.log(`money target: ${this.state[event.target.name + 'S']}`);
  }
  setItemStateChanged = (changed) => {
    this.setState({ itemStateHasChanged: changed });
    if (changed === true) {
      SessionInfo.setShowSave = 1; // Show Save in Header  
      if (this.clearScreen === true) {
        this.clearScreen = false;
        SessionInfo.setShowNew = 1;
      }
    } else
      SessionInfo.setShowSave = 2; // Turn Off
  }
  chgFldValMask(event,mask) {
    //console.log(`chg masked value: ${event.target.value}, mask: ${mask}`);
    this.setState({ [event.target.name]: UnmaskString(event.target.value,mask) });
    //console.log(`chg masked - name: ${event.target.name}:${event.target.value}`);
    this.setItemStateChanged(true);
  }
  chgFldVal(event) {
    this.setState({ [event.target.name]: event.target.value });
    //console.log(`${event.target.name}:${event.target.value}`);
    this.setItemStateChanged(true);
  }
  chgMoneyFldVal(event) {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g, ''); // Matches any single single character not in the bracket [] and replaces with ''  - https://www.infobyip.com/regularexpressioncalculator.php
    //console.log("money newval: " + newVal);
    this.setState({ [event.target.name]: newVal });
    this.setItemStateChanged(true);
  }
  chgPercentStart(event) {
    this.frmt = false;
    let newVal = event.target.value.replace(/[^\d.-]/g, '');
    console.log("start newval: " + newVal);
    this.setState({ [event.target.name]: newVal });
    this.setItemStateChanged(true);
  }
  chgPercFldVal(event) {
    let newVal = event.target.value.replace(/[^\d.-]/g, '');
    console.log("perc newval: " + newVal);
    this.setState({ [event.target.name]: newVal });
    this.setItemStateChanged(true);
  }
  chgPercentFldVal(event) {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g, '');
    console.log("percent blur newval: " + newVal);
    newVal /= 100.0;
    this.setState({ [event.target.name]: newVal });
    this.setItemStateChanged(true);
    this.frmt = true;
  }
  chgDDFldVal = (event) => {
    this.setState({ [event.target.props.name]: event.target.value.ddID });
    this.setItemStateChanged(true);
  }
  onChangeAmenities = (event) => {
    this.setState({ StoreAmenitiesVals: [...event.target.value] });
    console.log("Amenities: " + this.state.StoreAmenitiesVals);
  }
  chgCheckboxVal(event) {
    //console.log("stateCopy-" + event.target.name + " : " + JSON.stringify(this.state[event.target.name]));
    let setVal = true;
    if (this.state[event.target.name] === true)
      setVal = false;
    this.setState({ [event.target.name]: setVal });
    this.setItemStateChanged(true);
  }
  //-------------------------------

  customOrderItemsPageChange = (event) => {
    this.setState({ customOrderItemsSkip: event.page.skip, customOrderItemsTake: event.page.take });
  }
  selectionCustomOrderItemsChange = (event) => {
    event.dataItem.selected = !event.dataItem.selected;
    this.forceUpdate();
  }
  getCustomOrderItemsSort = (sort) => {
    return orderBy(this.state.CustomOrderItems, sort);
  }
  //------------------------- Select StoreItem from Main Database -------------------------------------------------------------------------
  mainStoreItemsPageChange = (event) => {
    this.setState({ mainStoreItemsSkip: event.page.skip, mainStoreItemsTake: event.page.take });
  }
  selectionStoreItemChange = (event) => {
    event.dataItem.selected = !event.dataItem.selected;
    this.forceUpdate();
  }
  rowStoreItemClick = async (event) => { // Copy ProductItem to Location Store Items
    if (!this.state.MainStoreItems)
      await this.saveRecord();
    //console.log("Invite  MainStoreItems: " + this.state.MainStoreItems);
    // turn off current and turn on new Selected indicator
    let last = this.lastMainSelectedIndex;
    const current = this.state.MainStoreItems.findIndex(dataItem => dataItem === event.dataItem);
    this.lastMainSelectedIndex = last = current;
    this.state.MainStoreItems.forEach(item => item.selected = false);
    const select = !event.dataItem.selected;
    for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
      this.state.MainStoreItems[i].selected = select;
    }
    let PKID = this.state.MainStoreItems[current].StoreItemID;
    let CD = await CallOM("CheckStoreItemExists", this.state.StoreLocationID, PKID, 0);
    let RetVal = CD.d;
    if (RetVal === 1)
      displayWarning("Item already exists for this location");
    else {
      //const item = { StoreLocationID: this.state.StoreLocationID, StoreItemID: PKID };  CopyStoreItemToStore()
      let item = JSON.parse(JSON.stringify(this.state.MainStoreItems[current])); // Object Copy - Value copy
      //console.log("item: " + JSON.stringify(item));
      item.StoreLocationID = this.state.StoreLocationID;
      item.ReferenceItemID = PKID;
      item.StoreItemID = 0;
      let index = this.state.StoreItems.findIndex(p => p.StoreItemID === PKID); // Look to see if already copied
      //console.log("Select PKID: " + PKID + " index: " + index);
      if (index < 0) {
        console.log("Save StoreItems - StoreLocationID: " + item.StoreLocationID + " StoreItemID: " + item.StoreItemID + " Ref: " + item.ReferenceItemID);
        let CD = await CallOM("CopyStoreItemToStore", this.state.StoreLocationID, PKID, 0);
        let RetVal = CD.d;
        if (RetVal === 1) {
          //await UpdateRow(544619, 0, this.state.StoreItems, item, 0, "StoreItemID"); Save Record - this does not work as did not load entire record
          await this.getStoreItems(); // Refresh StoreItems for this location
          // NOTE - need to delete copied row in MainStoreItems    
          //let data = this.state.MainStoreItems.splice(current, 1);
          let data = this.state.MainStoreItems.splice(current, 1); // Remove one entry and put entry in data
          this.setState({ MainStoreItems: this.state.MainStoreItems });
        }
        else
          displayWarning(`Item Copy for ${this.state.StoreItems[index].ItemName} Failed`);
      }
      else {
        displayWarning(this.state.StoreItems[index].ItemName + " - Item is already assigned to the Location");
      }
    }
  }
  onDisplayContract = async () => {
    window.open('https://rinkeby.etherscan.io/address/' + this.state.ProjectInstanceContractAddress, "_blank") //to open new page
  }
  onDisplayAccount = async () => {
    window.open('https://rinkeby.etherscan.io/address/' + this.state.MetaMaskAccount, "_blank") //to open new page
  }
  onDisplayTx = async () => {
    if (this.state.transactionHash === '')
      displayMessage("No Transaction Specified");
    else
      window.open('https://rinkeby.etherscan.io/tx/' + this.state.transactionHash, "_blank") //to open new page
  }
  sortChange = (event) => {
    this.setState({ products: this.GetProducts(event.sort), sort: event.sort });
  }
  getProductItemsSort = (sort) => {
    return orderBy(this.state.MainStoreItems, sort);
  }

  //------------------------- End Select StoreItem ----------------------------------------------------------------------

  onAdvanceCommand = async () => {
    console.log(`Advance Status for OrderID: ${this.state.CustomOrderID}`);
    let CD = await CallOM("AdvanceStatus", 0, this.state.CustomOrderID, 0); // Fetch CustomOrders based on OrderStatus
  }
  //onVerticalLayoutChange = (event) => {
  //  console.log("vertical: " + JSON.stringify(event.newState));
  //  this.setState({ verticalPanes: event.newState });
  //}
  onHorizontalLayoutChange = (event) => {
    //console.log("horizontal: " + JSON.stringify(updatedState));
    this.setState({ horizontalPanes: event.newState });
  }
  onHorizontalSubLayoutChange = (event) => {
    console.log("horizontal: " + JSON.stringify(event.newState));
    this.setState({ horizontalSubPanes: event.newState });
  }
  //------------------------- Task Board ----------------------------------------------------------------------
  onSearchChange = (event) => {
    this.setState({
      filter: event.value,
    });
  };
  onChangeHandler = (event) => {
    console.log(`changeHandler: ${JSON.stringify(event.data)}`);
    if (event.type === "column") {
      this.setState({columnsData: event.data,});
    } else {
      // New Task has been added.
      if (event.item && event.item.id === undefined) {
        event.item.id = event.data.length + 1;
      }
      this.setState({taskBrdData: event.data,});
    }
  };
  onAddColumn = () => {
    const newColumn = {
      id: this.state.columnsData.length + 1,
      title: "New GridColumn",
      status: "new",
      edit: true,
    };
    this.setState({
      columnsData: [...this.state.columnsData,newColumn],
    });
  };
  //------------------------- End Task Board ----------------------------------------------------------------------

  render() {
    //let filterDesc = { // For Task Board - not used
    //  logic: "and",
    //  filters: [
    //    {
    //      field: "title",
    //      operator: "contains",
    //      value: this.state.filter,
    //    },
    //  ],
    //};
    //let resultTasks = this.state.filter ? filterBy(this.state.taskBrdData,filterDesc) : this.state.taskBrdData;
    //console.log(`resultTask: ${JSON.stringify(resultTasks)}`)
    //}
    return (
      <div id="KitchenManagement" className="pageMain">
        <PageSide />
        <PageHeader L1='Home' Select='2' PageTitle='Kitchen Management' NoDelete='true' IsApp='y' ItemName='Location' />
        <div id="mainCntr">
          <Splitter style={{ height: '100%', border: 'none' }} panes={this.state.horizontalPanes} orientation={'horizontal'} onChange={this.onHorizontalLayoutChange}>
            <div id="splitterLeft" className="splitPaneContent">
              <Grid style={{ position: 'absolute', top: 0, height: '100%' }} data={this.state.StoreLocations} 
                onRowClick={this.storeLocationRowClick} resizable={true} sortable={true} pageable={true} pageSize={20}>
                <GridColumn field="StoreName" title="Store Name" width="140px" />
                <GridColumn field="CityName" title="City" width="120px" />
                <GridColumn field="Address" title="Address" width="150px" />
              </Grid>
            </div>
            <div id="splitterRight" className="splitPaneContent">
              <TabStrip selected={this.state.selectedTopTab} onSelect={this.handleTopTabSelect} className="tabStrip">
                <TabStripTab title="Kitchen Station" id="tabAnchor">
                  <div className="editTabWholeLow">
                    <div className="editField">
                      <span className="editFieldLabel">Station</span>
                      <div className="editDDPos">
                        <DropDownList data={this.state.Contacts} textField="ddName" dataItemKey="ddID" value={this.state.Contacts.find(c => c.ddID === this.state.ContactID)} name="ContactID" onChange={evt => this.chgDDFldVal(evt)} className="editInputDD" />  {/* defaultItem={this.contactName} */}
                      </div>
                    </div>
                    <div style={{ fontSize: "18px",color: "blue",width: "100%",whiteSpace: "nowrap" }}><span style={{ marginLeft: "30px" }}>Submitted Orders</span><span style={{ marginLeft: "30%" }}>Active Orders</span><span style={{ marginLeft: "30%" }}>Ready Orders</span></div>
                    <div> {/* All Orders - Pending,InProgress,Ready are in TilesInProgress */}
                      <TileLayout columns={3} rowHeight={60} gap={{ rows: 8,columns: 5 }} items={this.state.TilesInProgress} onReposition={this.repositionCurrent} ignoreDrag={this.testReposition}/>  {/* state.TilesInProgress */}
                    </div>
                  </div>
                </TabStripTab>
                {/*<TabStripTab title="Kitchen Panel" id="tabAnchor">*/}
                {/*  <div className="editTabWholeLow">*/}
                {/*    <TaskBoard columnData={this.state.columnsData} taskData={this.state.taskBrdData} priorities={priorities} onChange={this.onChangeHandler} style={{ height: "700px",}} tabIndex={0} >*/}
                {/*    </TaskBoard>*/}
                {/*  </div>*/}
                {/*</TabStripTab>*/}
                <TabStripTab title="Pending Orders" style={{ height: '100%', width: '100%' }}>
                  <div className="editTab">
                    <div className="editTabLeft">
                      <Grid style={{ position: 'absolute', top: 5, height: '98%' }} data={this.state.PendingOrders} 
                        onRowClick={this.orderRowClick} resizable={true} sortable={true} pageable={false}>
                        <GridColumn field="CustomOrderID" title="Order #" width="80px" />
                        <GridColumn field="CustomerID" title="Customer" width="110px" />
                        <GridColumn field="RequestDateTime" title="Request Time" cells={{ data: TimePickerCell }} width='125px' readOnly='true' />
                        <GridColumn field="TotalPrice" title="Total" cells={{ data: MoneyCell }} width='80px' />
                        <GridColumn field="TipAmount" title="Tip" cells={{ data: MoneyCell }} width='70px' />
                        <GridColumn field="ItemCount" title="Cnt" width="50px" />
                        <GridColumn field="OrderNotes" title="Notes" width="100px" />
                      </Grid>
                    </div>
                  </div>
                </TabStripTab>
                <TabStripTab title="Kitchen Orders" style={{ height: '100%',width: '100%' }}>
                  <div className="editTab">
                    <div className="editTabLeft">
                      <Grid style={{ position: 'absolute',top: 5,height: '98%' }} data={this.state.KitchenOrders} 
                        onRowClick={this.orderRowClick} resizable={true} sortable={true} pageable={false}>
                        <GridColumn field="CustomOrderID" title="Order #" width="80px" />
                        <GridColumn field="CustomerID" title="Customer" width="110px" />
                        <GridColumn field="RequestDateTime" title="Request Time" cells={{ data: TimePickerCell }} width='125px' readOnly='true' />
                        <GridColumn field="TotalPrice" title="Total" cells={{ data: MoneyCell }} width='80px' />
                        <GridColumn field="TipAmount" title="Tip" cells={{ data: MoneyCell }} width='70px' />
                        <GridColumn field="ItemCount" title="Cnt" width="50px" />
                        <GridColumn field="OrderNotes" title="Notes" width="100px" />
                      </Grid>
                    </div>
                  </div>
                </TabStripTab>
                <TabStripTab title="Ready To Serve">
                  <div className="editTab">
                    <div className="editTabLeft">
                      <Grid style={{ position: 'absolute', top: 5, height: '98%' }} data={this.state.ReadyOrders} 
                        onRowClick={this.orderRowClick} resizable={true} sortable={true} pageable={false}>
                        <GridColumn field="CustomOrderID" title="Order #" width="80px" />
                        <GridColumn field="CustomerID" title="Customer" width="110px" />
                        <GridColumn field="RequestDateTime" title="Request Time" cells={{ data: TimePickerCell }} width='125px' readOnly='true' />
                        <GridColumn field="TotalPrice" title="Total" cells={{ data: MoneyCell }} width='80px' />
                        <GridColumn field="TipAmount" title="Tip" cells={{ data: MoneyCell }} width='70px' />
                        <GridColumn field="ItemCount" title="Cnt" width="50px" />
                        <GridColumn field="OrderNotes" title="Notes" width="100px" />
                      </Grid>
                    </div>
                  </div>
                </TabStripTab>
                <TabStripTab title="Completed Orders">
                  <div className="editTab">
                    <div className="editTabLeft">
                      <Grid style={{ position: 'absolute', top: 5, height: '98%' }} data={this.state.CompletedOrders} 
                        onRowClick={this.orderRowClick} resizable={true} sortable={true} pageable={false}>
                        <GridColumn field="CustomOrderID" title="Order #" width="80px" />
                        <GridColumn field="CustomerID" title="Customer" width="110px" />
                        <GridColumn field="RequestDateTime" title="Request Time" cells={{ data: TimePickerCell }} width='125px' readOnly='true' />
                        <GridColumn field="TotalPrice" title="Total" cells={{ data: MoneyCell }} width='80px' />
                        <GridColumn field="TipAmount" title="Tip" cells={{ data: MoneyCell }} width='70px' />
                        <GridColumn field="ItemCount" title="Cnt" width="50px" />
                        <GridColumn field="OrderNotes" title="Notes" width="100px" />
                      </Grid>
                    </div>
                  </div>
                </TabStripTab>
                <TabStripTab title="Management">
                  <div className="editTab">
                    <div className="editTabTop">
                      <br />
                      <div className="editTabLeftNarrow">
                        <br />
                        <div id="div1" className="editInside">
                          <div className="editField">
                            <span className="editFieldLabel">Store Name</span>
                            <input value={this.state.StoreName} name="StoreName" onChange={evt => this.chgFldVal(evt)} className="editInput" />
                          </div>
                          <div className="editField">
                            <span className="editFieldLabel">Description</span>
                            <input value={this.state.Description} name="Description" onChange={evt => this.chgFldVal(evt)} className="editInput" />
                          </div>
                          <div className="editField">
                            <span className="editFieldLabel">Location Name</span>
                            <input value={this.state.LocationName} name="LocationName" onChange={evt => this.chgFldVal(evt)} className="editInput" />
                          </div>
                          <div className="editField">
                            <span className="editFieldLabel">Store Manager</span>
                            <div className="editDDPos">
                              <DropDownList data={this.state.Contacts} textField="ddName" dataItemKey="ddID" value={this.state.Contacts.find(c => c.ddID === this.state.ContactID)} name="ContactID" onChange={evt => this.chgDDFldVal(evt)} className="editInputDD" />  {/* defaultItem={this.contactName} */}
                            </div>
                          </div>
                          <br />
                          <div className="editField">
                            <span className="editFieldLabel">Sub-Location</span>
                            <div className="editDDPos">
                              <DropDownList data={this.state.Sublocations} textField="ddName" dataItemKey="ddID" value={this.state.Sublocations.find(c => c.ddID === this.state.SublocationID)} name="SublocationID" onChange={evt => this.chgDDFldVal(evt)} className="editInputDD" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="editTabMiddle">
                        <div id="div1" className="editInside">
                          <h4>Control Values</h4>
                          <div className="editField">
                            <span className="editFieldLabel">Store Group</span>
                            <div className="editDDPos">
                              <DropDownList data={this.state.StoreGroups} textField="ddName" dataItemKey="ddID" value={this.state.StoreGroups.find(c => c.ddID === this.state.StoreGroupID)} name="StoreGroupID" onChange={evt => this.chgDDFldVal(evt)} className="editInputDD" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="editTabRightNarrow">
                        <div id="div1" className="editInside">
                          <h4>Taxes</h4>
                          <div id="div2" className="editField">
                            <span className="editFieldLabel">Outstanding Orders</span>
                            <NumericTextBox format="p1" name="TaxRate" value={this.state.TaxRate} min={0.0} max={0.3} step={0.01} onChange={evt => this.chgFldVal(evt)} width={100} className="NumTxtExtShortInput" />
                          </div>
                          <div id="div2" className="editField">
                            <span className="editFieldLabel">Average Time Per Order</span>
                            <NumericTextBox format="p1" name="TaxRate2" value={this.state.TaxRate2} min={0.0} max={0.3} step={0.01} onChange={evt => this.chgFldVal(evt)} width={100} className="NumTxtExtShortInput" />
                          </div>
                          <div id="div2" className="editField">
                            <span className="editFieldLabel">Current Wait Time</span>
                            <NumericTextBox format="p1" name="TaxRate3" value={this.state.TaxRate3} min={0.0} max={0.3} step={0.01} onChange={evt => this.chgFldVal(evt)} width={100} className="NumTxtExtShortInput" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabStripTab>
                <TabStripTab title="Schedule">
                  <div className="editTabWholeLow">
                    <SchedControl TaskData={this.state.SchedulerData} />
                  </div>
                </TabStripTab>
              </TabStrip>
            </div>
            {/* Side Pane - Receipt Details */}
            <div id="splitterRight" className="splitPaneContent">
              <Splitter style={{ height: '100%', border: 'none' }} panes={this.state.verticalPanes} orientation={'vertical'} onChange={this.onVerticalLayoutChange}>
                <div className="editPane">  {/* Receipt Details */}
                  <div className="editTabLeft">
                    <div id="div1" className="editInside">
                      <h4>Receipt Details</h4>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Customer</span>
                        <input value={this.state.CustomerID} name="CustomerID" onChange={evt => this.chgFldVal(evt)} className="editInput" readonly={true} />
                      </div>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Receipt #</span>
                        <input value={this.state.CustomOrderID} name="CustomOrderID" onChange={evt => this.chgFldVal(evt)} className="editInputMedium" readonly={true} />
                      </div>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Order Status</span>
                        <input value={this.state.CustomOrderStatus} name="CustomOrderStatus" onChange={evt => this.chgFldVal(evt)} className="editInputMedium" readonly={true} />
                      </div>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Order Type</span>
                        <input value={this.state.CustomOrderType} name="CustomOrderType" onChange={evt => this.chgFldVal(evt)} className="editInputMedium" readonly={true} />
                      </div>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Order Date</span>
                        <div className="editDDPos">
                          <DateTimePicker value={new Date(this.state.OrderCreationDate)} name="OrderCreationDate" onChange={evt => this.chgFldVal(evt)} className="editDateInput" readonly={true} />
                          {/*<DateTimePicker value={this.state.OrderCreationDate < new Date(2000, 1, 1) ? new Date(2000, 1, 1) : new Intl.DateTimeFormat("en-CA", { dateStyle: "long", timeStyle: "short" }).format(this.state.OrderCreationDate)} name="OrderCreationDate" onChange={evt => this.chgFldVal(evt)} className="editDateInput" readonly={true} />*/}
                        </div>
                      </div>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Order Paid Date</span>
                        <div className="editDDPos">
                          <DateTimePicker value={new Date(this.state.OrderPaidDate)} name="OrderPaidDate" onChange={evt => this.chgFldVal(evt)} className="editDateInput" readonly={true} />
                        </div>
                      </div>
                      <div className="editField">
                        <span className="editFieldLabel">Payment Method</span>
                        <input value={this.state.PaymentMethodTypeID} name="PaymentMethodTypeID" onChange={evt => this.chgFldVal(evt)} className="editInputMedium" readonly={true} />
                      </div>
                      <div id='div2' className='editField'>
                        <span className='editFieldLabel'>Comments</span>
                        <input value={this.state.OrderNotes} name='OrderNotes' onChange={evt => this.chgFldVal(evt)} className='editInput' readonly={true} />
                      </div>
                      <div id='div2' className='editField'>
                        <span className='editFieldLabel'>Paid Comment</span>
                        <input value={this.state.PaidComment} name='PaidComment' onChange={evt => this.chgFldVal(evt)} className='editInput' readonly={true} />
                      </div>
                      {this.state.selectedTopTab >= 10 ?
                        <div>
                          <h4>Delivery</h4>
                          <div id='div2' className='editField'>
                            <span className='editFieldLabel'>Address</span>
                            <textarea value={this.state.Address} name='Address' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                          </div>
                          <br />
                          <br />
                          <div id='div2' className='editField'>
                            <span className='editFieldLabel'>Phone Number</span>
                            <MaskedTextBox value={MaskString(this.state.PhoneNumber,"(###) ###-####")} name='PhoneNumber' onChange={evt => this.chgFldValMask(evt,"(###) ###-####")} mask="(999) 000-0000" className='editPhoneInput' />
                          </div>
                        </div> : null}
                      <br />

                      <div className="editField">
                        <Button icon="arrow-seek-right" color="primary" onClick={this.onAdvanceCommand}>Advance Status</Button>
                      </div>
                      <br />
                    </div>
                  </div>
                  <div className="editTabRight">
                    <div id="div1" className="editInside">
                      <h4>Receipt Totals</h4>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Total Price</span>
                        <input value={this.moneyFormat(this.state.TotalPrice)} name="TotalPrice" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                      </div>
                      {SessionInfo.AppCfg & ENAppCnfg.HasDiscounts ?
                        <div id="div2" className="editField">
                          <span className="editFieldLabel">Discount Amount</span>
                          <input value={this.moneyFormat(this.state.DiscountAmount)} name="DiscountAmount" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                        </div> : null}
                      {SessionInfo.AppCfg & ENAppCnfg.HasCredit ?
                        <div className="editField">
                          <span className="editFieldLabel">Credit Amount Used</span>
                          <input value={this.moneyFormat(this.state.CreditAmountUsed)} name="CreditAmountUsed" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                        </div> : null}
                      {SessionInfo.AppCfg & ENAppCnfg.HasReturns ?
                        <div className="editField">
                          <span className="editFieldLabel">Refund Amount</span>
                          <input value={this.moneyFormat(this.state.RefundAmount)} name="RefundAmount" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                        </div> : null}
                      {SessionInfo.AppCfg & ENAppCnfg.HasTax1 ?
                        <div className="editField">
                          <span className="editFieldLabel">Tax Amount</span>
                          <input value={this.moneyFormat(this.state.TotalTaxAmount)} name="TotalTaxAmount" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                        </div> : null}
                      {SessionInfo.AppCfg & ENAppCnfg.HasTax2 ?
                        <div className="editField">
                          <span className="editFieldLabel">Tax2 Amount</span>
                          <input value={this.moneyFormat(this.state.TotalTax2Amount)} name="TotalTax2Amount" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                        </div> : null}
                      {SessionInfo.AppCfg & ENAppCnfg.HasTax3 ?
                        <div className="editField">
                          <span className="editFieldLabel">Tax3 Amount</span>
                          <input value={this.moneyFormat(this.state.TotalTax2Amount)} name="TotalTax3Amount" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                        </div> : null}
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Total Amount</span>
                        <input value={this.moneyFormat(this.state.TotalAmount)} name="TotalAmount" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                      </div>

                      <h4>Receipt Totals</h4>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Amount Paid</span>
                        <input value={this.moneyFormat(this.state.AmountPaid)} name="AmountPaid" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                      </div>
                      <div className="editField">
                        <span className="editFieldLabel">Tip Amount</span>
                        <input value={this.moneyFormat(this.state.TipAmount)} name="TipAmount" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                      </div>
                      <div id="div2" className="editField">
                        <span className="editFieldLabel">Total Paid</span>
                        <input value={this.moneyFormat(this.state.AmountPaidWithTip)} name="AmountPaidWithTip" onChange={evt => this.chgMoneyFldVal(evt)} className="editMoneyInput" readonly={true} />
                      </div>
                    </div>
                  </div> {/* End of Receipt */}
                </div> 
                <div id="splitterBottom">
                  <Grid style={{ position: 'absolute', top: 0, height: '100%' }} data={this.state.CustomOrderItems.slice(this.state.customOrderItemsSkip, this.state.customOrderItemsTake + this.state.customOrderItemsSkip)}  sortable={{ allowUnsort: true, mode: 'multiple' }}
                    skip={this.state.customOrderItemsSkip} take={this.state.customOrderItemsTake} total={this.state.CustomOrderItems.length} onPageChange={this.selectionCustomOrderItemsChange}
                    onRowClick={this.rowStoreItemClick}  resizable={true} sort={this.state.sortCustomOrderItems} onSortChange={(event) => { this.setState({ CustomOrderItems: this.getCustomOrderItemsSort(event.sort), customOrderItemsSort: event.sort }); }}
                    pageable={{ info: true, type: 'numeric', pageSizes: true, previousNext: true }}
                    pageSize={18}>
                    <GridColumn field="StoreItemID" title="Item Name" width='200px' />
                    <GridColumn field="Quantity" title="Qty" width='60px' />
                    <GridColumn field="OptionCount" title="Options" width='80px' />
                    <GridColumn field="TotalPrice" title="Price" cells={{ data: MoneyCell }} width='120px' />
                  </Grid>
                </div>
              </Splitter>
            </div>
          </Splitter>
          {/*------ Help List Popup ------*/}
          <Popup offset={this.helpListPopupOffset} show={this.state.showHelpListPopup} popupClass={'popupHelp'} >
            <div id="helpBox">
              <div className="helpList">
                <ListView data={this.state.HelpPages} item={this.HelpPageFormat} header={this.HelpPageHeader} footer={this.HelpPageFooter} />
              </div>
              <br />
            </div>
          </Popup>
          {/*------ Help Detail Popup ------*/}
          <Popup offset={this.helpDetailOffset} show={this.state.showHelpDetail} popupClass={'popupHelpDetail'} onClick={this.closeHelpTime}>
            <div className="frameInfo" id="notifyBoxPU" dangerouslySetInnerHTML={{ __html: this.state.helpDetail }} onClick={this.closeHelpTime}></div>
          </Popup>
        </div >
        {SessionInfo.displayFooter === true ?
          <PageFooter L1='Home' IsApp='y' /> : null}
        {/*------ Scheduler Popup ------*/}
        <Popup offset={this.popupOffset} show={this.state.showPopup} popupClass={'popup-content'} >  {/*anchor={this.anchor} */}
          <div id="setTime" className="createPopUP">
            <div id="div2" className="editField">
              <span className="editFieldLabel">Customer Name</span>
              <span className="editInput">{this.state.CustomerName}</span>
            </div>
            <div id="div2" className="editField">
              <span className="editFieldLabel">Scheduled Date</span>
              <div className="editDDPos">
                <DateTimePicker value={new Date(this.state.ScheduledPrepDateTime)} name="ScheduledPrepDateTime" onChange={evt => this.chgFldVal(evt)} className="editDateInput" readonly={true} />
                {/*<DateTimePicker value={this.state.OrderCreationDate < new Date(2000, 1, 1) ? new Date(2000, 1, 1) : new Intl.DateTimeFormat("en-CA", { dateStyle: "long", timeStyle: "short" }).format(this.state.OrderCreationDate)} name="OrderCreationDate" onChange={evt => this.chgFldVal(evt)} className="editDateInput" readonly={true} />*/}
              </div>
            </div>
            <div id="div2" className="editField">
              <span className="editFieldLabel">Adjust Time</span>
              <img src={require("./images/Arrow3Left.png")} alt="" id="MinuteMinus" title="Minus Minutes" className="functionImage" onClick={this.ClickMinus} />
              <img src={require("./images/Arrow3Right.png")} alt="" id="MinutePlus" title="Plus Minutes" className="functionImage" onClick={this.ClickPlus} />
            </div>
          </div>
        </Popup>
      </div >
    );
  }
}

export default withRouter(KitchenManagement);